import querystring from 'query-string';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import React, { useEffect, createContext, useContext, useState, useRef, Fragment as Fragment$1, useReducer, Component, forwardRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Spinner, Button, Modal, Row, Col, Form, InputGroup, Alert, Carousel, Dropdown, Container, Nav, Breadcrumb, Card, Pagination, Table } from 'react-bootstrap';
import axios from 'axios';
import { createSlice, configureStore } from '@reduxjs/toolkit';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { LinkContainer } from 'react-router-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle, faTimesCircle, faExclamationTriangle, faInfoCircle, faCheckSquare, faSquare, faDotCircle, faCircle, faCompressAlt, faExpandAlt, faAngleUp, faAngleDown, faBars, faCaretUp, faCaretDown, faEllipsisH, faAngleDoubleLeft, faAngleLeft, faAngleRight, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
import { createBrowserHistory } from 'history';
import { wrapHistory } from 'oaf-react-router';
import { combineReducers } from 'redux';
import { useQuery } from 'react-query';
import objectPath from 'object-path';
import { useFormContext, useForm, FormProvider } from 'react-hook-form';
import 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Link, useLocation, Navigate, Routes, Route, useMatch, useNavigate } from 'react-router-dom';
import { parseStringPromise } from 'xml2js';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$w =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$i = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$h = fails$i;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$h(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var fails$g = fails$i;

var functionBindNative = !fails$g(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$2 = functionBindNative;

var call$b = Function.prototype.call;

var functionCall = NATIVE_BIND$2 ? call$b.bind(call$b) : function () {
  return call$b.apply(call$b, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var bind = FunctionPrototype$2.bind;
var call$a = FunctionPrototype$2.call;
var uncurryThis$k = NATIVE_BIND$1 && bind.bind(call$a, call$a);

var functionUncurryThis = NATIVE_BIND$1 ? function (fn) {
  return fn && uncurryThis$k(fn);
} : function (fn) {
  return fn && function () {
    return call$a.apply(fn, arguments);
  };
};

var uncurryThis$j = functionUncurryThis;

var toString$9 = uncurryThis$j({}.toString);
var stringSlice$5 = uncurryThis$j(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$5(toString$9(it), 8, -1);
};

var global$v = global$w;
var uncurryThis$i = functionUncurryThis;
var fails$f = fails$i;
var classof$5 = classofRaw$1;

var Object$5 = global$v.Object;
var split = uncurryThis$i(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$f(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object$5('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$5(it) == 'String' ? split(it, '') : Object$5(it);
} : Object$5;

var global$u = global$w;

var TypeError$a = global$u.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$7 = function (it) {
  if (it == undefined) throw TypeError$a("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$6 = requireObjectCoercible$7;

var toIndexedObject$5 = function (it) {
  return IndexedObject$1(requireObjectCoercible$6(it));
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$i = function (argument) {
  return typeof argument == 'function';
};

var isCallable$h = isCallable$i;

var isObject$6 = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$h(it);
};

var global$t = global$w;
var isCallable$g = isCallable$i;

var aFunction = function (argument) {
  return isCallable$g(argument) ? argument : undefined;
};

var getBuiltIn$4 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$t[namespace]) : global$t[namespace] && global$t[namespace][method];
};

var uncurryThis$h = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$h({}.isPrototypeOf);

var getBuiltIn$3 = getBuiltIn$4;

var engineUserAgent = getBuiltIn$3('navigator', 'userAgent') || '';

var global$s = global$w;
var userAgent = engineUserAgent;

var process$1 = global$s.process;
var Deno = global$s.Deno;
var versions = process$1 && process$1.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es-x/no-symbol -- required for testing */

var V8_VERSION = engineV8Version;
var fails$e = fails$i;

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$e(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/* eslint-disable es-x/no-symbol -- required for testing */

var NATIVE_SYMBOL$2 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var global$r = global$w;
var getBuiltIn$2 = getBuiltIn$4;
var isCallable$f = isCallable$i;
var isPrototypeOf$1 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var Object$4 = global$r.Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$2('Symbol');
  return isCallable$f($Symbol) && isPrototypeOf$1($Symbol.prototype, Object$4(it));
};

var global$q = global$w;

var String$4 = global$q.String;

var tryToString$1 = function (argument) {
  try {
    return String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var global$p = global$w;
var isCallable$e = isCallable$i;
var tryToString = tryToString$1;

var TypeError$9 = global$p.TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$1 = function (argument) {
  if (isCallable$e(argument)) return argument;
  throw TypeError$9(tryToString(argument) + ' is not a function');
};

var aCallable = aCallable$1;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$3 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};

var global$o = global$w;
var call$9 = functionCall;
var isCallable$d = isCallable$i;
var isObject$5 = isObject$6;

var TypeError$8 = global$o.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$d(fn = input.toString) && !isObject$5(val = call$9(fn, input))) return val;
  if (isCallable$d(fn = input.valueOf) && !isObject$5(val = call$9(fn, input))) return val;
  if (pref !== 'string' && isCallable$d(fn = input.toString) && !isObject$5(val = call$9(fn, input))) return val;
  throw TypeError$8("Can't convert object to primitive value");
};

var shared$4 = {exports: {}};

var global$n = global$w;

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;

var setGlobal$3 = function (key, value) {
  try {
    defineProperty$5(global$n, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$n[key] = value;
  } return value;
};

var global$m = global$w;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$m[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.22.5',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.22.5/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var global$l = global$w;
var requireObjectCoercible$5 = requireObjectCoercible$7;

var Object$3 = global$l.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$4 = function (argument) {
  return Object$3(requireObjectCoercible$5(argument));
};

var uncurryThis$g = functionUncurryThis;
var toObject$3 = toObject$4;

var hasOwnProperty = uncurryThis$g({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$3(it), key);
};

var uncurryThis$f = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$8 = uncurryThis$f(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$8(++id + postfix, 36);
};

var global$k = global$w;
var shared$3 = shared$4.exports;
var hasOwn$9 = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$1 = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var WellKnownSymbolsStore = shared$3('wks');
var Symbol$1 = global$k.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$c = function (name) {
  if (!hasOwn$9(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL$1 || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL$1 && hasOwn$9(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var global$j = global$w;
var call$8 = functionCall;
var isObject$4 = isObject$6;
var isSymbol$1 = isSymbol$2;
var getMethod$2 = getMethod$3;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$b = wellKnownSymbol$c;

var TypeError$7 = global$j.TypeError;
var TO_PRIMITIVE = wellKnownSymbol$b('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$4(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$2(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$8(exoticToPrim, input, pref);
    if (!isObject$4(result) || isSymbol$1(result)) return result;
    throw TypeError$7("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$i = global$w;
var isObject$3 = isObject$6;

var document$1 = global$i.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$3(document$1) && isObject$3(document$1.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

var DESCRIPTORS$a = descriptors;
var fails$d = fails$i;
var createElement = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$a && !fails$d(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var DESCRIPTORS$9 = descriptors;
var call$7 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$8 = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$9 ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$8(O, P)) return createPropertyDescriptor$2(!call$7(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$8 = descriptors;
var fails$c = fails$i;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$8 && fails$c(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var global$h = global$w;
var isObject$2 = isObject$6;

var String$3 = global$h.String;
var TypeError$6 = global$h.TypeError;

// `Assert: Type(argument) is Object`
var anObject$9 = function (argument) {
  if (isObject$2(argument)) return argument;
  throw TypeError$6(String$3(argument) + ' is not an object');
};

var global$g = global$w;
var DESCRIPTORS$7 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$8 = anObject$9;
var toPropertyKey = toPropertyKey$2;

var TypeError$5 = global$g.TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$7 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$8(O);
  P = toPropertyKey(P);
  anObject$8(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$8(O);
  P = toPropertyKey(P);
  anObject$8(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError$5('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$6 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;

var createNonEnumerableProperty$6 = DESCRIPTORS$6 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$2 = {exports: {}};

var DESCRIPTORS$5 = descriptors;
var hasOwn$7 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$5 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$7(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$5 || (DESCRIPTORS$5 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$e = functionUncurryThis;
var isCallable$c = isCallable$i;
var store$1 = sharedStore;

var functionToString = uncurryThis$e(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$c(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$2 = store$1.inspectSource;

var global$f = global$w;
var isCallable$b = isCallable$i;
var inspectSource$1 = inspectSource$2;

var WeakMap$1 = global$f.WeakMap;

var nativeWeakMap = isCallable$b(WeakMap$1) && /native code/.test(inspectSource$1(WeakMap$1));

var shared$2 = shared$4.exports;
var uid = uid$2;

var keys = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$e = global$w;
var uncurryThis$d = functionUncurryThis;
var isObject$1 = isObject$6;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$6;
var hasOwn$6 = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$4 = global$e.TypeError;
var WeakMap = global$e.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$1(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$4('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  var wmget = uncurryThis$d(store.get);
  var wmhas = uncurryThis$d(store.has);
  var wmset = uncurryThis$d(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError$4(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn$6(it, STATE)) throw new TypeError$4(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$5(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$6(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$6(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var fails$b = fails$i;
var isCallable$a = isCallable$i;
var hasOwn$5 = hasOwnProperty_1;
var DESCRIPTORS$4 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource = inspectSource$2;
var InternalStateModule$1 = internalState;

var enforceInternalState = InternalStateModule$1.enforce;
var getInternalState$2 = InternalStateModule$1.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$4 = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS$4 && !fails$b(function () {
  return defineProperty$4(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$1 = makeBuiltIn$2.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$5(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    defineProperty$4(value, 'name', { value: name, configurable: true });
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$5(options, 'arity') && value.length !== options.arity) {
    defineProperty$4(value, 'length', { value: options.arity });
  }
  if (options && hasOwn$5(options, 'constructor') && options.constructor) {
    if (DESCRIPTORS$4) try {
      defineProperty$4(value, 'prototype', { writable: false });
    } catch (error) { /* empty */ }
  } else value.prototype = undefined;
  var state = enforceInternalState(value);
  if (!hasOwn$5(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$1(function toString() {
  return isCallable$a(this) && getInternalState$2(this).source || inspectSource(this);
}, 'toString');

var global$d = global$w;
var isCallable$9 = isCallable$i;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$6;
var makeBuiltIn = makeBuiltIn$2.exports;
var setGlobal$1 = setGlobal$3;

var defineBuiltIn$4 = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  if (isCallable$9(value)) makeBuiltIn(value, name, options);
  if (O === global$d) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return O;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$4(O, key, value);
  return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$4 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor$1 : ceil)(number);
};

var toIntegerOrInfinity$3 = toIntegerOrInfinity$4;

var max$1 = Math.max;
var min$2 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$3(index);
  return integer < 0 ? max$1(integer + length, 0) : min$2(integer, length);
};

var toIntegerOrInfinity$2 = toIntegerOrInfinity$4;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$2 = function (argument) {
  return argument > 0 ? min$1(toIntegerOrInfinity$2(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$1 = toLength$2;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$1 = function (obj) {
  return toLength$1(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike = lengthOfArrayLike$1;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var uncurryThis$c = functionUncurryThis;
var hasOwn$4 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$1 = uncurryThis$c([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$4(hiddenKeys$2, key) && hasOwn$4(O, key) && push$1(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$4(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$1(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$1 = getBuiltIn$4;
var uncurryThis$b = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$7 = anObject$9;

var concat$2 = uncurryThis$b([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$1('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$7(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$3 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$2 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$2.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$3(target, key) && !(exceptions && hasOwn$3(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$a = fails$i;
var isCallable$8 = isCallable$i;

var replacement = /#|\.prototype\./;

var isForced$1 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$8(detection) ? fails$a(detection)
    : !!detection;
};

var normalize = isForced$1.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = 'N';
var POLYFILL = isForced$1.POLYFILL = 'P';

var isForced_1 = isForced$1;

var global$c = global$w;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$6;
var defineBuiltIn$3 = defineBuiltIn$4;
var setGlobal = setGlobal$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$c;
  } else if (STATIC) {
    target = global$c[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$c[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$3(sourceProperty, 'sham', true);
    }
    defineBuiltIn$3(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$3 = descriptors;
var uncurryThis$a = functionUncurryThis;
var call$6 = functionCall;
var fails$9 = fails$i;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$2 = toObject$4;
var IndexedObject = indexedObject;

// eslint-disable-next-line es-x/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var defineProperty$3 = Object.defineProperty;
var concat$1 = uncurryThis$a([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$9(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$3 && $assign({ b: 1 }, $assign(defineProperty$3({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$3(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es-x/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys$1($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$2(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$3 || call$6(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$7 = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$$7({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

const APPLICATION_TYPE = {
  REENTRY_PERMIT: 1,
  REFUGEE_TRAVEL: 2,
  REFUGEE_TRAVEL_RESIDENT: 3,
  ADVANCE_PAROLE_TEMP: 4,
  ADVANCE_PAROLE_OUTSIDE: 5,
  ADVANCE_PAROLE_PERSON_OUTSIDE: 6
};
const FORM_TYPE = {
  I131: 1
};
const APPLICATION_STATUS = {
  IN_PROGRESS: 1,
  SUBMITTED: 2,
  ACCEPTED: 3,
  APPROVED: 5,
  DENIED: 6
};
const APPLICATION_STEPS = {
  INFORMATION_ABOUT_YOU: 1,
  PROCESSING_INFORMATION: 2,
  TRAVEL_INFORMATION: 3,
  REENTRY_PERMIT_INFORMATION: 4,
  EVIDENCE: 5,
  REVIEW_SUBMIT: 6
};

const ERROR_INVALID_ZIP_CODE = 'Invalid Zip Code.  ';
const ZIP_CORRECTION_MODAL = 'Zip code is invalid. Please enter a correct Zip code and try again.';
const CASE_TYPE_OTHER = 'O';
const DATE_FORMAT_INPUT = 'yyyy-MM-dd';
const CASE_SERVICE = 'case-service';
const AUTH_SERVICE = 'auth-service';
const PRIMARY_COLOR = '#006699';
const PREVIOUS = 'Previous';
const NEXT = 'Next';
const CANCEL = 'Cancel';
const DELETE = 'Delete';
const ERROR_FILE_TYPE = 'Invalid file - file is not an acceptable type';
const ERROR_FILE_EMPTY = 'Invalid file - file is empty';
const ERROR_INVALID_PATTERN = 'Invalid format';
const ERROR_SERVER_GENERIC = 'The application has encountered an unknown error. Ensure your entered information is correct before trying again.';
const TEN_MEGABYTES = 10000000;
const ACCEPTABLE_FILE_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];
const ACCEPTABLE_FILE_HINT = 'Acceptable file types are PDF, JPEG, and PNG';
const UPLOAD_HELP = 'Only one file can be uploaded per case.';
const FILE_UPLOAD_PLACEHOLDER = 'Choose file...';
const NO_NAME_PROVIDED = 'No name provided';
const APP_NAME = 'vSTART';
const HELP = 'Help';
const MENU = 'Menu';
const CLOSE = 'Close';
const CLOSE_NAVIGATION = 'Close navigation';
const HOME = 'Home';
const MY_PROFILE = 'My Profile';
const SIGN_OUT = 'Sign out';
const CANCEL_APP = 'Cancel Application';
const CONFIRM_WITHOUT_SAVING = 'Please confirm you want to continue without saving.';
const CONFIRM_REMOVE_FILE = 'Please confirm you want to remove the file.';
const ERROR_SELECT_OPTION = 'Make a selection';
const NOT_AVAILABLE = 'Not Available';
const PREVIOUS_BUTTON = 'Previous';
const SUBMIT = 'Submit';
const CONFIRM = 'Confirm';
const SELECT_DEFAULT_OPTION_LABEL = 'Choose...';
const LANDING_WELCOME = 'Welcome to USCIS';
const SIGN_IN = 'Sign In';
const SIGN_UP = 'Sign Up';
const PROFILE_EDIT = 'Edit Profile';
const PROFILE_ERROR = 'An error occurred during profile update.';
const REFRESH_TOKEN_FAIL = 'Unable to refresh authorization token.';
const SIGNED_OUT_ISSUE = 'You were signed out due to inactivity or a connectivity issue.'; // Case Management

const CASE_MANAGEMENT = 'Case Management'; // STRING UTILITIES

const CONFIRM_DELETE = itemName => `Please confirm you want to delete this ${itemName}.`;
const DATE_FORMAT_DISPLAY = ({
  displayTime
} = {}) => {
  if (displayTime) return 'MM/dd/yyyy h:mmaa'; // ex: 12/25/2020 12:00AM

  return 'MM/dd/yyyy'; // ex: 12/25/2020
};
const ERROR_MESSAGE_REQUIRED = fieldName => `${fieldName ? fieldName : 'This'} is a required field`;
const ERROR_MAX_CHAR = maxNumber => `Exceeds maximum character limit (${maxNumber})`;
const ERROR_MIN_CHAR = minNumber => `Must exceed minimum character limit (${minNumber})`;
const ERROR_EXACT_CHAR = number => `Must input exactly ${number} characters`;
const ERROR_ON_OR_BEFORE_TODAY = fieldName => `${fieldName ? fieldName : 'This field'} must be on or before today's date`;
const ERROR_ON_OR_BEFORE_DATE = (fieldName, compareVal) => `${fieldName} must be on or before ${compareVal}`;
const ERROR_ON_OR_AFTER_DATE = (fieldName, compareVal) => `${fieldName} must be on or after ${compareVal}`;
const ERROR_DATE_FORMAT = fieldName => `${fieldName} must be a valid date`;
const ERROR_MAX_FILE_SIZE = fileSize => `Invalid file - file exceeds the maximum ${fileSize} file size limit`;
const HELPTEXT_MESSAGE = charTypes => `Only ${charTypes} are allowed; other characters are not accepted`;
const APPLICATION_TYPE_HELP_TEXT = {
  [APPLICATION_TYPE.REENTRY_PERMIT]: `<h4 data-testid="reentry-help">Reentry Permit</h4><p>Select this if you are a lawful permanent resident or conditional permanent resident who wants to apply for readmission to the United States upon returning from abroad.</p>`
};
const APPLICATION_INSTRUCTIONAL_TEXT = 'All fields marked with a red asterisk * are required. While not all fields are required, please fill out each question as accurately as possible to minimize delays in the approval process.';
const PERSONAL_INFO_STEP = 'Personal Information';
const PROCESSING_INFO_STEP = 'Processing Information';
const PROPOSED_TRAVEL_DETAILS_STEP = 'Proposed Travel Details';
const REENTRY_PERMIT_INFO_STEP = 'Reentry Permit Information';
const EVIDENCE_STEP = 'Evidence';
const REVIEW_AND_SUBMIT_STEP = 'Review & Submit';
const alphanumericPattern = /^[a-z0-9]+$/i;
const alphaHyphenSpacePattern = /^[a-z- ]+$/i;
const alphaHyphenApostrophePattern = /^[a-z-']+$/i;
const alphanumericSpaceSlashPattern = /^[a-z0-9 /]+$/i;
const alphaSpaceSlashPattern = /^[a-z /]+$/i;
const alphaSpacePattern = /^[a-z ]+$/i;
const alphaNumericSpacePattern = /^[a-z0-9 ]+$/i;
const numericPattern = /^[0-9]+$/i;
const NICKNAME_DEFAULT_VALUE = 'NNN';

const {
  NODE_ENV,
  REACT_APP_API_SERVICE,
  REACT_APP_COGNITO_APP,
  REACT_APP_COGNITO_CLIENT,
  REACT_APP_COGNITO_REDIRECT_URL,
  REACT_APP_SERVICE_AUTH
} = (process === null || process === void 0 ? void 0 : process.env) || {};

const serviceUrls = {
  [AUTH_SERVICE]: REACT_APP_SERVICE_AUTH || `${REACT_APP_API_SERVICE}/auth`
};
function cognitoUrl(state, isSignup) {
  const params = Object.assign({
    client_id: REACT_APP_COGNITO_CLIENT,
    response_type: 'code',
    scope: 'openid+email+profile',
    redirect_uri: REACT_APP_COGNITO_REDIRECT_URL
  }, state ? {
    state
  } : {});
  const paramsAsString = querystring.stringify(params, {
    encode: false
  });
  const location = isSignup ? 'signup' : 'login';
  return `https://${REACT_APP_COGNITO_APP}/${location}?${paramsAsString}`;
}
const refreshTokenUrl = () => `${serviceUrls[AUTH_SERVICE]}/refresh`;
const signOutUrl = () => `${serviceUrls[AUTH_SERVICE]}/sign-out`;

function VLoader(props) {
  const {
    color = 'primary',
    animation = 'border',
    size
  } = props;
  return jsx("div", Object.assign({
    className: "spinner-wrapper"
  }, {
    children: jsx(Spinner, Object.assign({
      animation: animation,
      variant: color,
      size: size ? 'sm' : undefined,
      role: "status",
      "data-testid": "loading-spinner"
    }, {
      children: jsx("span", Object.assign({
        className: "visually-hidden"
      }, {
        children: "Loading..."
      }), void 0)
    }), void 0)
  }), void 0);
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

serviceUrls[AUTH_SERVICE];

function VButtonRaw(props) {
  const {
    isPill,
    className,
    children
  } = props,
        rest = __rest(props, ["isPill", "className", "children"]);

  return jsx(Button, Object.assign({
    className: classnames(className, {
      'pill-button': isPill
    })
  }, rest, {
    children: children
  }), void 0);
}

function VButton(props) {
  const {
    id,
    'data-testid': dataTestId,
    children,
    className,
    disabled = false,
    href,
    target = '_top',
    onClick,
    size,
    to,
    type,
    variant,
    isPill = false // this is just ignored for now, its causing issues
    // noActive,

  } = props;

  if (to) {
    return jsx(LinkContainer, Object.assign({
      to: to
    }, {
      children: jsx(VButtonRaw, Object.assign({}, {
        id,
        type,
        disabled,
        className,
        variant,
        size,
        isPill,
        'data-testid': dataTestId
      }, {
        children: children
      }), void 0)
    }), void 0);
  }

  if (href) {
    // Since links can't normally be disabled, render a button instead
    if (disabled) {
      return jsx(VButtonRaw, Object.assign({}, {
        id,
        type,
        disabled,
        className,
        variant,
        size,
        isPill,
        'data-testid': dataTestId
      }, {
        children: children
      }), void 0);
    }

    return jsx("a", Object.assign({
      className: classnames(`btn btn-${variant} ${className || ''}`, {
        'pill-button': isPill
      }),
      id: id,
      "data-testid": dataTestId,
      href: href,
      target: target
    }, {
      children: children
    }), void 0);
  }

  return jsx(VButtonRaw, Object.assign({}, {
    id,
    type,
    disabled,
    className,
    variant,
    size,
    onClick,
    isPill,
    'data-testid': dataTestId
  }, {
    children: children
  }), void 0);
}
VButton.defaultProps = {
  type: 'button',
  variant: 'primary'
};
VButton.propTypes = {
  /** type of button */
  type: PropTypes.oneOf(['button', 'submit']),
  isPill: PropTypes.bool,

  /** style variants */
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark', 'link', 'outline-primary', 'outline-secondary', 'outline-success', 'outline-danger', 'outline-warning', 'outline-info', 'outline-light', 'outline-dark']),

  /** id used for tests */
  'data-testid': PropTypes.string
};

library.add(faCheckCircle, faTimesCircle, faExclamationTriangle, faInfoCircle);
function getAlertIcon(variant) {
  switch (variant) {
    case 'success':
      return 'check-circle';

    case 'danger':
      return 'times-circle';

    case 'warning':
      return 'exclamation-triangle';

    default:
      return 'info-circle';
  }
}

function VModalHeader(props) {
  const {
    title,
    variant
  } = props;
  const alertIcon = getAlertIcon(variant);

  if (!title) {
    return null;
  }

  return jsx(Modal.Header, Object.assign({
    closeButton: true,
    "data-testid": "modal-header"
  }, {
    children: jsxs(Modal.Title, Object.assign({
      as: "h4",
      id: "modal-title-id"
    }, {
      children: [jsx(FontAwesomeIcon, {
        id: `${variant}-icon`,
        icon: alertIcon,
        className: `vstart-modal-icon me-1`
      }, void 0), title]
    }), void 0)
  }), void 0);
}

function VModal(props) {
  const {
    actions,
    children,
    title,
    variant,
    onAnswer,
    className,
    size
  } = props;
  return jsx(Modal, Object.assign({
    show: true,
    className: className,
    centered: true,
    onHide: () => onAnswer(false),
    contentClassName: `vstart-modal vstart-modal-${variant}`,
    title: title,
    "aria-labelledby": title ? 'modal-title-id' : 'modal-body-id',
    size: size
  }, {
    children: jsx(Row, {
      children: jsxs(Col, {
        children: [jsx(VModalHeader, Object.assign({}, {
          variant,
          title
        }), void 0), jsx(Modal.Body, Object.assign({
          id: "modal-body-id"
        }, {
          children: children
        }), void 0), jsx(Modal.Footer, {
          children: actions.map(action => jsx(VButton, Object.assign({
            variant: action.variant,
            onClick: () => onAnswer(action.value),
            size: "sm",
            "data-testid": `modal-action-${action.value}`
          }, {
            children: action.label
          }), action.label))
        }, void 0)]
      }, void 0)
    }, void 0)
  }), void 0);
}

function createConfirmation(options) {
  const {
    actions,
    callback,
    children,
    title,
    variant,
    className
  } = options;
  const modal = document.createElement('div');

  function onAnswer(answer) {
    ReactDOM.unmountComponentAtNode(modal);
    document.body.removeChild(modal);
    callback(answer);
  }

  const element = jsx(VModal, Object.assign({}, {
    actions,
    title,
    variant,
    onAnswer,
    className
  }, {
    children: children
  }), void 0);

  document.body.appendChild(modal);
  ReactDOM.render(element, modal);
}

let history$1;
const oafReactRouterSettings = {
  primaryFocusTarget: '#virtual-cursor-home',
  announcePageNavigation: true
};
function createHistory() {
  if (!history$1) {
    history$1 = createBrowserHistory({// getUserConfirmation(message, callback) {
      //   createConfirmation({
      //     variant: 'warning',
      //     actions: [
      //       {
      //         label: 'Continue',
      //         variant: 'primary',
      //         value: true,
      //       },
      //       {
      //         label: 'Cancel',
      //         variant: 'link',
      //         value: false,
      //       },
      //     ],
      //     callback,
      //     children: message,
      //   });
      // },
    });

    if (process.env['NODE_ENV'] !== 'test') {
      wrapHistory(history$1, oafReactRouterSettings);
    }

    history$1.listen(location => {// TODO: This is where some analytics might go
    });
  }

  return history$1;
}

const initialState$2 = {
  isLoading: true
};
const authSlice = createSlice({
  name: 'auth',
  initialState: initialState$2,
  reducers: {
    reset() {
      return initialState$2;
    },

    dismissError(state) {
      return Object.assign(Object.assign({}, state), {
        errorMessage: undefined
      });
    },

    setError(state, action) {
      return Object.assign(Object.assign({}, state), {
        errorMessage: action.payload
      });
    },

    failedAuth(state, action) {
      if (action.payload && state.user) {
        setTimeout(() => {
          createConfirmation({
            variant: 'warning',
            actions: [{
              label: CLOSE,
              variant: 'primary',
              value: true
            }],
            callback: () => {// intentionally blank
            },
            children: action.payload || ''
          });
        });
      }

      return {
        isLoading: false,
        errorMessage: action.payload || ''
      };
    },

    successAuth(state, action) {
      return {
        isLoading: false,
        user: action.payload
      };
    }

  }
});
const {
  reset,
  failedAuth,
  successAuth,
  dismissError,
  setError
} = authSlice.actions;

let apiRequestDispatch;
function configureApiRequest(dispatch) {
  apiRequestDispatch = dispatch;
}
function apiRequest(url, options) {
  var _a;

  return __awaiter(this, void 0, void 0, function* () {
    const {
      method = 'get',
      data,
      params,
      headers = {
        Accept: 'application/json'
      },
      withCredentials = true,
      handleUnauthorized = true,
      throwErrors = true
    } = options || {};

    try {
      const {
        status,
        data: responseData
      } = yield axios({
        url,
        method,
        data,
        params,
        headers,
        withCredentials
      });
      return {
        status,
        data: responseData
      };
    } catch (err) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (handleUnauthorized && ((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
        if (apiRequestDispatch) {
          apiRequestDispatch(failedAuth(SIGNED_OUT_ISSUE));
        } else {
          console.error('Redux Store Dispatch has not been configured, this will prevent the apiRequest util from logging the user out in the case of an expired token.');
        }
      }

      if (throwErrors) {
        throw err;
      } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore


      return err === null || err === void 0 ? void 0 : err.response;
    }
  });
}

const baseUrl = serviceUrls[AUTH_SERVICE];
const getMeUrl = () => `${baseUrl}/me`;
function getMe() {
  return apiRequest(getMeUrl(), {
    handleUnauthorized: false
  });
}

const getRefreshUrl = refreshTokenUrl;
function getRefresh() {
  return apiRequest(getRefreshUrl());
}

const ONE_MINUTE = 1000 * 60;
const FIVE_MINUTES = ONE_MINUTE * 5;
let refreshTimeout;
function refreshTimeoutHandler(options) {
  return __awaiter(this, void 0, void 0, function* () {
    const {
      callback,
      dispatch,
      triesRemaining
    } = options;

    try {
      const {
        data
      } = yield getRefresh();
      const {
        tokenExpiresIn
      } = data; // Clear Timeout

      refreshTimeout = undefined; // Create a new Timeout

      callback({
        dispatch,
        expiresIn: tokenExpiresIn - FIVE_MINUTES
      });
    } catch (err) {
      // Clear Timeout
      refreshTimeout = undefined; // Retry in 1 minute with one less possible try

      callback({
        dispatch,
        expiresIn: ONE_MINUTE,
        triesRemaining: triesRemaining - 1
      });
    }
  });
}
function createRefreshTimeout({
  dispatch,
  expiresIn,
  triesRemaining = 3,
  handler = refreshTimeoutHandler
}) {
  if (triesRemaining === 0) {
    dispatch(failedAuth(REFRESH_TOKEN_FAIL));
    return;
  }

  if (!refreshTimeout && expiresIn) {
    refreshTimeout = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
      yield handler({
        dispatch,
        callback: createRefreshTimeout,
        triesRemaining
      });
    }), expiresIn);
  }
}
function checkAuthentication(params) {
  return dispatch => __awaiter(this, void 0, void 0, function* () {
    try {
      let redirect;

      if (params) {
        const {
          state
        } = params;
        redirect = state || '/';
      }

      const {
        data
      } = yield getMe();

      const _a = data,
            {
        tokenExpiresIn
      } = _a,
            user = __rest(_a, ["tokenExpiresIn"]);

      dispatch(successAuth(user));
      createRefreshTimeout({
        dispatch,
        expiresIn: tokenExpiresIn ? tokenExpiresIn - FIVE_MINUTES : 0
      });

      if (redirect) {
        createHistory().push(redirect);
      }
    } catch (err) {
      dispatch(failedAuth());
    }
  });
}

function authSelector(state) {
  return state.auth;
}
function authErrorSelector(state) {
  return state.auth.errorMessage;
}
function authUserSelector(state) {
  return state.auth.user;
}
function authLoadingSelector(state) {
  return state.auth.isLoading;
}

function formSelector(state) {
  return state.form;
}

function useAuthentication() {
  const {
    isLoading,
    user
  } = useSelector(authSelector);
  return {
    isLoading,
    user
  };
}

function signOut() {
  window.location.href = signOutUrl();
}

function useAuthenticationSignOut() {
  const {
    isDirty
  } = useSelector(formSelector);
  return () => {
    if (isDirty) {
      createConfirmation({
        variant: 'warning',
        actions: [{
          label: 'Continue',
          variant: 'primary',
          value: true
        }, {
          label: 'Cancel',
          variant: 'link',
          value: false
        }],
        callback: answer => {
          answer && signOut();
        },
        children: CONFIRM_WITHOUT_SAVING
      });
    } else {
      signOut();
    }
  };
}
function AuthenticationContextProvider(props) {
  const {
    children
  } = props;
  const dispatch = useDispatch();
  const isLoading = useSelector(authLoadingSelector);
  useEffect(() => {
    dispatch(checkAuthentication());
  }, [dispatch]);

  if (isLoading) {
    return jsx(VLoader, {}, void 0);
  }

  return jsx("div", Object.assign({
    id: "authentication-context",
    className: "authentication-context"
  }, {
    children: children
  }), void 0);
}

const initialState$1 = {
  documentTitle: 'Welcome to vSTART',
  header: {}
};
const pageSlice = createSlice({
  name: 'page',
  initialState: initialState$1,
  reducers: {
    pageUpdate(_, action) {
      return action.payload;
    }

  }
});
const {
  pageUpdate
} = pageSlice.actions;
function usePageUpdate(pageState) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(pageUpdate(pageState));
  }, [dispatch, pageState]);
}

const initialState = {
  isDirty: false
};
const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    formUpdate(_, action) {
      return action.payload;
    }

  }
});
formSlice.actions;

const rootReducer = {
  auth: authSlice.reducer,
  form: formSlice.reducer,
  page: pageSlice.reducer
};

combineReducers(rootReducer);
const createRootReducer = (reducers = {}) => combineReducers(Object.assign(Object.assign({}, rootReducer), reducers));

const createStore = (configs = {}) => {
  const {
    customReducers = {},
    middleware = {}
  } = configs;
  const rootReducer = createRootReducer(customReducers);
  const store = configureStore(Object.assign({
    reducer: rootReducer
  }, middleware));
  return {
    store
  };
};

const vSkipNavContext = /*#__PURE__*/createContext(() => {// This is intentionally blank
});
function useVSkipNav(target) {
  const setTarget = useContext(vSkipNavContext);
  useEffect(() => {
    setTarget(target);
  }, [target, setTarget]);
}

var objectDefineProperties = {};

var DESCRIPTORS$2 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$1 = objectDefineProperty;
var anObject$6 = anObject$9;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$2 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$6(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$1.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn = getBuiltIn$4;

var html$1 = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */

var anObject$5 = anObject$9;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$5(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$a = wellKnownSymbol$c;
var create$2 = objectCreate;
var definePropertyModule = objectDefineProperty;

var UNSCOPABLES = wellKnownSymbol$a('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$2(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$8 = fails$i;

var correctPrototypeGetter = !fails$8(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var global$b = global$w;
var hasOwn$2 = hasOwnProperty_1;
var isCallable$7 = isCallable$i;
var toObject$1 = toObject$4;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var Object$2 = global$b.Object;
var ObjectPrototype = Object$2.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? Object$2.getPrototypeOf : function (O) {
  var object = toObject$1(O);
  if (hasOwn$2(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$7(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object$2 ? ObjectPrototype : null;
};

var fails$7 = fails$i;
var isCallable$6 = isCallable$i;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$2 = defineBuiltIn$4;
var wellKnownSymbol$9 = wellKnownSymbol$c;

var ITERATOR$2 = wellKnownSymbol$9('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es-x/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails$7(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$2].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$6(IteratorPrototype$2[ITERATOR$2])) {
  defineBuiltIn$2(IteratorPrototype$2, ITERATOR$2, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$2 = objectDefineProperty.f;
var hasOwn$1 = hasOwnProperty_1;
var wellKnownSymbol$8 = wellKnownSymbol$c;

var TO_STRING_TAG$3 = wellKnownSymbol$8('toStringTag');

var setToStringTag$2 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$1(target, TO_STRING_TAG$3)) {
    defineProperty$2(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$1 = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$1 = setToStringTag$2;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$1 = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$1(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$1(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var global$a = global$w;
var isCallable$5 = isCallable$i;

var String$2 = global$a.String;
var TypeError$3 = global$a.TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$5(argument)) return argument;
  throw TypeError$3("Can't set " + String$2(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThis$9 = functionUncurryThis;
var anObject$4 = anObject$9;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis$9(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$4(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$6 = _export;
var call$5 = functionCall;
var FunctionName = functionName;
var isCallable$4 = isCallable$i;
var createIteratorConstructor = createIteratorConstructor$1;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$2;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$6;
var defineBuiltIn$1 = defineBuiltIn$4;
var wellKnownSymbol$7 = wellKnownSymbol$c;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$1 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol$7('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$1 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$4(CurrentIteratorPrototype[ITERATOR$1])) {
          defineBuiltIn$1(CurrentIteratorPrototype, ITERATOR$1, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$2(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$5(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$1(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$6({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$1] !== defaultIterator) {
    defineBuiltIn$1(IterablePrototype, ITERATOR$1, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$1 = addToUnscopables$2;
var Iterators = iterators;
var InternalStateModule = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator = defineIterator$1;
var DESCRIPTORS$1 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState$1 = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$1 && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$9 = global$w;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$6;
var wellKnownSymbol$6 = wellKnownSymbol$c;

var ITERATOR = wellKnownSymbol$6('iterator');
var TO_STRING_TAG$2 = wellKnownSymbol$6('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty$1(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$2]) {
      createNonEnumerableProperty$1(CollectionPrototype, TO_STRING_TAG$2, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$9[COLLECTION_NAME] && global$9[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

function useVPaginatedQuery({
  queryKey,
  queryFn,
  limit = 10,
  defaultSortDir,
  defaultSortBy,
  defaultPage = 1,
  params
}) {
  const [page, setPage] = useState(defaultPage);
  const [sortBy, setSortBy] = useState(defaultSortBy);
  const [sortDir, setSortDir] = useState(defaultSortDir);
  const pages = useRef(1);
  const resultCount = useRef(0);
  const paginatedResults = useQuery([queryKey, {
    page,
    sortBy,
    sortDir,
    params
  }], () => __awaiter(this, void 0, void 0, function* () {
    const {
      results,
      count
    } = yield queryFn({
      page,
      limit,
      sortBy,
      sortDir,
      params
    });
    resultCount.current = count;
    pages.current = Math.ceil(count / limit);
    return results;
  }));
  return Object.assign(Object.assign({}, paginatedResults), {
    pages: pages.current,
    count: resultCount.current,
    sortBy,
    setSortBy,
    sortDir,
    setSortDir,
    page,
    limit,
    setPage
  });
}

var wellKnownSymbol$5 = wellKnownSymbol$c;

var TO_STRING_TAG$1 = wellKnownSymbol$5('toStringTag');
var test$1 = {};

test$1[TO_STRING_TAG$1] = 'z';

var toStringTagSupport = String(test$1) === '[object z]';

var global$8 = global$w;
var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$3 = isCallable$i;
var classofRaw = classofRaw$1;
var wellKnownSymbol$4 = wellKnownSymbol$c;

var TO_STRING_TAG = wellKnownSymbol$4('toStringTag');
var Object$1 = global$8.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$4 = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object$1(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$3(O.callee) ? 'Arguments' : result;
};

var global$7 = global$w;
var classof$3 = classof$4;

var String$1 = global$7.String;

var toString$7 = function (argument) {
  if (classof$3(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String$1(argument);
};

var anObject$3 = anObject$9;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$3(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var fails$6 = fails$i;
var global$6 = global$w;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$6.RegExp;

var UNSUPPORTED_Y$1 = fails$6(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$1 || fails$6(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$1 || fails$6(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$1
};

var fails$5 = fails$i;
var global$5 = global$w;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$5.RegExp;

var regexpUnsupportedDotAll = fails$5(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

var fails$4 = fails$i;
var global$4 = global$w;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$4.RegExp;

var regexpUnsupportedNcg = fails$4(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$4 = functionCall;
var uncurryThis$8 = functionUncurryThis;
var toString$6 = toString$7;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4.exports;
var create = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$3 = uncurryThis$8(''.charAt);
var indexOf = uncurryThis$8(''.indexOf);
var replace$3 = uncurryThis$8(''.replace);
var stringSlice$4 = uncurryThis$8(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$4(nativeExec, re1, 'a');
  call$4(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$6(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$4(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$4(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$3(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$4(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$3(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$4(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$4(match.input, charsAdded);
        match[0] = stringSlice$4(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      call$4(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$5 = _export;
var exec = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$5({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

var NATIVE_BIND = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$1 = FunctionPrototype.apply;
var call$3 = FunctionPrototype.call;

// eslint-disable-next-line es-x/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call$3.bind(apply$1) : function () {
  return call$3.apply(apply$1, arguments);
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var uncurryThis$7 = functionUncurryThis;
var defineBuiltIn = defineBuiltIn$4;
var regexpExec$1 = regexpExec$2;
var fails$3 = fails$i;
var wellKnownSymbol$3 = wellKnownSymbol$c;
var createNonEnumerableProperty = createNonEnumerableProperty$6;

var SPECIES = wellKnownSymbol$3('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$3(KEY);

  var DELEGATES_TO_SYMBOL = !fails$3(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$3(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis$7(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis$7(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

var uncurryThis$6 = functionUncurryThis;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$4;
var toString$5 = toString$7;
var requireObjectCoercible$4 = requireObjectCoercible$7;

var charAt$2 = uncurryThis$6(''.charAt);
var charCodeAt = uncurryThis$6(''.charCodeAt);
var stringSlice$3 = uncurryThis$6(''.slice);

var createMethod$1 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$5(requireObjectCoercible$4($this));
    var position = toIntegerOrInfinity$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$2(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$3(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};

var charAt$1 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt$1(S, index).length : 1);
};

var uncurryThis$5 = functionUncurryThis;
var toObject = toObject$4;

var floor = Math.floor;
var charAt = uncurryThis$5(''.charAt);
var replace$2 = uncurryThis$5(''.replace);
var stringSlice$2 = uncurryThis$5(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$2(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$2(str, 0, position);
      case "'": return stringSlice$2(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$2(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var global$3 = global$w;
var call$2 = functionCall;
var anObject$2 = anObject$9;
var isCallable$2 = isCallable$i;
var classof$2 = classofRaw$1;
var regexpExec = regexpExec$2;

var TypeError$2 = global$3.TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$2(exec)) {
    var result = call$2(exec, R, S);
    if (result !== null) anObject$2(result);
    return result;
  }
  if (classof$2(R) === 'RegExp') return call$2(regexpExec, R, S);
  throw TypeError$2('RegExp#exec called on incompatible receiver');
};

var apply = functionApply;
var call$1 = functionCall;
var uncurryThis$4 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var fails$2 = fails$i;
var anObject$1 = anObject$9;
var isCallable$1 = isCallable$i;
var toIntegerOrInfinity = toIntegerOrInfinity$4;
var toLength = toLength$2;
var toString$4 = toString$7;
var requireObjectCoercible$3 = requireObjectCoercible$7;
var advanceStringIndex = advanceStringIndex$1;
var getMethod$1 = getMethod$3;
var getSubstitution = getSubstitution$1;
var regExpExec$1 = regexpExecAbstract;
var wellKnownSymbol$2 = wellKnownSymbol$c;

var REPLACE = wellKnownSymbol$2('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis$4([].concat);
var push = uncurryThis$4([].push);
var stringIndexOf$1 = uncurryThis$4(''.indexOf);
var stringSlice$1 = uncurryThis$4(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$2(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic$1('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$3(this);
      var replacer = searchValue == undefined ? undefined : getMethod$1(searchValue, REPLACE);
      return replacer
        ? call$1(replacer, searchValue, O, replaceValue)
        : call$1(nativeReplace, toString$4(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$1(this);
      var S = toString$4(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf$1(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf$1(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable$1(replaceValue);
      if (!functionalReplace) replaceValue = toString$4(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec$1(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString$4(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$4(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          var replacement = toString$4(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$1(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice$1(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

function useVFormContext(name, label) {
  var _a;

  const formContext = useFormContext();
  const {
    watch,
    formState
  } = formContext;
  const {
    errors
  } = formState;
  const error = objectPath.get(errors, name);
  const hasErrors = !!error;
  const errorMessageWithLabel = (_a = error === null || error === void 0 ? void 0 : error.message) === null || _a === void 0 ? void 0 : _a.replace(name, label);
  const value = watch(name);
  return Object.assign(Object.assign({}, formContext), {
    error: Object.assign(Object.assign({}, error), {
      message: errorMessageWithLabel
    }),
    hasErrors,
    value
  });
}

var SortDirection;

(function (SortDirection) {
  SortDirection["ASC"] = "asc";
  SortDirection["DESC"] = "desc";
})(SortDirection || (SortDirection = {}));

function VOptional(props) {
  const {
    show = true,
    children,
    ariaChangeNotice
  } = props;
  return jsx("div", Object.assign({
    className: "vstart-region-holder",
    "aria-live": ariaChangeNotice ? 'assertive' : 'polite'
  }, {
    children: show === true && jsxs(Fragment, {
      children: [ariaChangeNotice && jsx("p", Object.assign({
        className: "visually-hidden"
      }, {
        children: ariaChangeNotice
      }), void 0), children]
    }, void 0)
  }), void 0);
}

function getFieldIds(field) {
  const id = `${field}-id`;
  const helpId = `${id}-help`;
  const errorId = `${id}-error`;
  const alertErrorId = `${id}-alert-error`;
  return {
    id,
    helpId,
    errorId,
    alertErrorId
  };
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".instructional-text {\n  font-size: 0.75rem;\n  margin-bottom: 0;\n}";
styleInject(css_248z);

const VFormContext = /*#__PURE__*/createContext(undefined);
function VForm(props) {
  const {
    children,
    schema,
    onSubmit,
    defaultValues,
    className
  } = props,
        useFormConfigs = __rest(props, ["children", "schema", "onSubmit", "defaultValues", "className"]);

  const alertIds = useRef(new Set());
  const formMethods = useForm(Object.assign({
    resolver: schema ? yupResolver(schema) : undefined,
    defaultValues
  }, useFormConfigs));
  const {
    handleSubmit,
    reset,
    setValue
  } = formMethods;
  return jsx(FormProvider, Object.assign({}, formMethods, {
    children: jsx("form", Object.assign({
      onSubmit: handleSubmit((data, event) => onSubmit(data, event, reset, setValue)),
      className: className ? `vstart-form ${className}` : 'vstart-form'
    }, {
      children: jsx(VFormContext.Provider, Object.assign({
        value: alertIds
      }, {
        children: children
      }), void 0)
    }), void 0)
  }), void 0);
}

function useGetAlertRef(name) {
  const alertIds = useContext(VFormContext);
  return () => {
    var _a;

    return ((_a = alertIds === null || alertIds === void 0 ? void 0 : alertIds.current) === null || _a === void 0 ? void 0 : _a.has(name)) || false;
  };
}

function VFieldError(props) {
  const {
    error,
    errorId,
    hasErrors,
    errorComponent
  } = props;

  if (errorComponent) {
    return jsx("div", Object.assign({
      id: errorId,
      className: classnames({
        'vstart-error mb-3': hasErrors,
        'd-none': !hasErrors
      }),
      "data-testid": errorId
    }, {
      children: errorComponent()
    }), void 0);
  }

  return jsx(Form.Control.Feedback, Object.assign({
    id: errorId,
    type: "invalid",
    className: classnames({
      'vstart-error mb-3': hasErrors,
      'd-none': !hasErrors
    }),
    "data-testid": errorId
  }, {
    children: error === null || error === void 0 ? void 0 : error['message']
  }), void 0);
}

function VFieldHelpText(props) {
  const {
    helpText,
    helpId
  } = props;
  return jsx(Form.Text, Object.assign({
    id: helpId,
    "data-testid": helpId,
    color: "muted",
    className: classnames('mb-1', {
      'd-none': !helpText
    })
  }, {
    children: helpText
  }), void 0);
}

function VFieldReturnToError(props) {
  const {
    hasAlertError,
    alertErrorId
  } = props;
  return jsx(VOptional, Object.assign({
    show: hasAlertError
  }, {
    children: jsx(Form.Text, Object.assign({
      "data-testid": "alertError",
      id: `${alertErrorId}-return-link`
    }, {
      children: jsx(Link, Object.assign({
        to: `#${alertErrorId}`
      }, {
        children: "Return to error message"
      }), void 0)
    }), void 0)
  }), void 0);
}

function RawVFieldWrapper(props) {
  var _a;

  const {
    alertErrorId,
    children,
    error,
    errorId,
    hasAlertError,
    hasErrors,
    helpId,
    helpText,
    id,
    isLabelHidden,
    label,
    required,
    prependText,
    appendText,
    maxlength,
    hasMaxLengthWidget,
    value,
    errorComponent
  } = props;
  const isInputGroup = !!(prependText || appendText);
  return jsxs(Form.Group, {
    children: [jsxs(Form.Label, Object.assign({
      id: `${id}-label`,
      htmlFor: id,
      className: classnames({
        'visually-hidden': isLabelHidden
      })
    }, {
      children: [label, required && jsx("span", Object.assign({
        className: "vstart-required"
      }, {
        children: " *"
      }), void 0)]
    }), void 0), isInputGroup && jsxs(InputGroup, {
      children: [!!prependText && jsx(InputGroup.Text, Object.assign({
        className: "font-weight-normal"
      }, {
        children: prependText
      }), void 0), children, jsx("div", {
        className: classnames({
          'd-none': !hasErrors,
          'is-invalid': hasErrors
        })
      }, void 0), !!appendText && jsx(InputGroup.Text, Object.assign({
        className: "font-weight-normal"
      }, {
        children: appendText
      }), void 0)]
    }, void 0), !isInputGroup && jsxs(Fragment, {
      children: [children, jsx("div", {
        className: classnames({
          'd-none': !hasErrors,
          'is-invalid': hasErrors
        })
      }, void 0)]
    }, void 0), jsx(VFieldHelpText, Object.assign({}, {
      helpId,
      helpText
    }), void 0), hasMaxLengthWidget && maxlength && jsxs("p", Object.assign({
      className: "instructional-text"
    }, {
      children: [maxlength - ((_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0), " characters remaining."]
    }), void 0), jsx(VFieldError, Object.assign({}, {
      errorId,
      error,
      hasErrors,
      errorComponent
    }), void 0), jsx(VFieldReturnToError, Object.assign({}, {
      hasAlertError,
      alertErrorId
    }), void 0)]
  }, void 0);
}

function VFieldWrapper(props) {
  const {
    name
  } = props;
  const fieldIds = getFieldIds(name);
  const hasAlertError = useGetAlertRef(name);
  return jsx(RawVFieldWrapper, Object.assign({}, Object.assign(Object.assign(Object.assign({}, props), fieldIds), {
    hasAlertError: hasAlertError()
  })), void 0);
}

function RawVInputField(props) {
  const {
    id,
    as,
    name,
    hasErrors,
    innerRef,
    describedBy,
    type,
    handleChange,
    onChange,
    handleBlur,
    onBlur
  } = props,
        inputProps = __rest(props, ["id", "as", "name", "hasErrors", "innerRef", "describedBy", "type", "handleChange", "onChange", "handleBlur", "onBlur"]);

  function changeHandler(event) {
    if (handleChange) {
      handleChange(event);
    }

    onChange(event);
  }

  function blurHandler(event) {
    if (handleBlur) {
      handleBlur(event);
    }

    onBlur(event);
  }

  return jsx(Form.Control, Object.assign({}, Object.assign(Object.assign({}, inputProps), {
    id,
    as,
    name,
    onChange: changeHandler,
    onBlur: blurHandler,
    type,
    invalid: hasErrors ? 'true' : 'false',
    ref: innerRef,
    isInvalid: hasErrors,
    'aria-describedby': describedBy || undefined,
    'data-testid': `input-field-${id}`
  })), void 0);
}

function VInputField(props) {
  const {
    name,
    as,
    required,
    helpText,
    label,
    prependText,
    type,
    handleChange,
    handleBlur,
    isLabelHidden
  } = props,
        inputProps = __rest(props, ["name", "as", "required", "helpText", "label", "prependText", "type", "handleChange", "handleBlur", "isLabelHidden"]);

  const {
    register,
    error,
    hasErrors,
    value
  } = useVFormContext(name, label);
  const {
    id,
    helpId,
    errorId
  } = getFieldIds(name);
  const describedBy = classnames({
    [helpId]: !!helpText,
    [errorId]: hasErrors
  });

  const _a = register(name, {
    required
  }),
        {
    ref: innerRef
  } = _a,
        registerOut = __rest(_a, ["ref"]);

  return jsx(VFieldWrapper, Object.assign({}, Object.assign(Object.assign({}, props), {
    value,
    hasErrors,
    error,
    isLabelHidden: type === 'hidden' ? true : isLabelHidden
  }), {
    children: jsx(RawVInputField, Object.assign({}, Object.assign(Object.assign(Object.assign(Object.assign({}, inputProps), {
      key: id,
      handleChange,
      handleBlur,
      type,
      id,
      as,
      hasErrors,
      innerRef
    }), registerOut), {
      'aria-describedby': describedBy || undefined,
      'aria-required': required
    })), void 0)
  }), void 0);
}

function RawVSelectField(props) {
  const {
    id,
    hasErrors,
    describedBy,
    innerRef,
    required,
    helpText,
    options,
    handleChange,
    onChange,
    showDefault = true
  } = props,
        inputProps = __rest(props, ["id", "hasErrors", "describedBy", "innerRef", "required", "helpText", "options", "handleChange", "onChange", "showDefault"]);

  function changeHandler(event) {
    if (handleChange) {
      handleChange(event);
    }

    onChange(event);
  }

  return jsxs(Form.Control, Object.assign({}, Object.assign(Object.assign({}, inputProps), {
    id,
    invalid: hasErrors ? 'true' : 'false',
    isInvalid: hasErrors,
    as: 'select',
    defaultValue: inputProps.defaultValue || '',
    ref: innerRef,
    'aria-describedby': describedBy || undefined,
    'aria-required': required,
    onChange: changeHandler
  }), {
    "data-testid": `input-field-${id}`
  }, {
    children: [jsx("option", Object.assign({
      value: "",
      disabled: required,
      hidden: !showDefault
    }, {
      children: SELECT_DEFAULT_OPTION_LABEL
    }), "default"), (options === null || options === void 0 ? void 0 : options.length) ? options.map(option => jsx("option", Object.assign({
      value: option.value,
      disabled: option.disabled
    }, {
      children: option.label
    }), option.value)) : 'Loading...']
  }), void 0);
}

function VSelectField(props) {
  const {
    name,
    label
  } = props;

  const {
    required,
    helpText,
    options,
    handleChange
  } = props,
        inputProps = __rest(props, ["required", "helpText", "options", "handleChange"]);

  const {
    register,
    error,
    hasErrors
  } = useVFormContext(name, label);
  const {
    id,
    helpId,
    errorId
  } = getFieldIds(name);
  const describedBy = classnames({
    [helpId]: !!helpText,
    [errorId]: hasErrors
  });

  const _a = register(name, {
    required
  }),
        {
    ref: innerRef
  } = _a,
        registerOut = __rest(_a, ["ref"]);

  return jsx(VFieldWrapper, Object.assign({}, Object.assign(Object.assign({}, props), {
    hasErrors,
    error
  }), {
    children: jsx(RawVSelectField, Object.assign({}, Object.assign(Object.assign(Object.assign({}, inputProps), registerOut), {
      required,
      handleChange,
      id,
      hasErrors,
      innerRef,
      options,
      'aria-describedby': describedBy || undefined,
      'aria-required': required
    })), void 0)
  }), void 0);
}

const validateUrl = xmlReq => `https://secure.shippingapis.com/ShippingAPI.dll?API=Verify&XML=${xmlReq}`;
const userId = '332VENTE2173';
const buildXml = ({
  address1,
  address2,
  city,
  state,
  zip
}) => `<AddressValidateRequest USERID="${userId}">
    <Revision>1</Revision>
    <Address ID="0">
    <Address1>${address1}</Address1>
    <Address2>${address2}</Address2>
    <City>${city}</City>
    <State>${state}</State>
    <Zip5>${zip}</Zip5>
    <Zip4/>
    </Address>
   </AddressValidateRequest>`;
function validateAddress(address) {
  return __awaiter(this, void 0, void 0, function* () {
    const xmlReq = buildXml(address);
    return axios.get(encodeURI(validateUrl(xmlReq)));
  });
}

function RawAddressDisplay({
  address1,
  address2,
  city,
  state,
  zip
}) {
  return jsxs(Fragment, {
    children: [jsx("p", {
      children: `${address1} ${address2 || ''}`
    }, void 0), jsx("p", {
      children: `${city}, ${state} ${zip}`
    }, void 0)]
  }, void 0);
}

function AddressConfirmationModal({
  suggestedAddress,
  enteredAddress
}) {
  return jsxs(Fragment, {
    children: [jsx(Row, {
      children: jsx(Col, {
        children: jsx("p", {
          children: "The address you provided does not match the United States Postal Service verified address. Please select the address you want to use or return to the form and edit your address."
        }, void 0)
      }, void 0)
    }, void 0), jsx(Row, {
      children: jsx(Col, {
        children: jsxs("section", {
          children: [jsx("b", {
            children: "Verified USPS Address"
          }, void 0), jsx(RawAddressDisplay, Object.assign({}, {
            address1: suggestedAddress.address1,
            address2: suggestedAddress === null || suggestedAddress === void 0 ? void 0 : suggestedAddress.address2,
            city: suggestedAddress.city,
            zip: suggestedAddress.zip,
            state: suggestedAddress.state
          }), void 0)]
        }, void 0)
      }, void 0)
    }, void 0), jsx(Row, {
      children: jsx(Col, {
        children: jsxs("section", {
          children: [jsx("b", {
            children: "Address I Entered"
          }, void 0), jsx(RawAddressDisplay, Object.assign({}, {
            address1: enteredAddress.addressLine1,
            address2: enteredAddress === null || enteredAddress === void 0 ? void 0 : enteredAddress.addressLine2,
            city: enteredAddress.city,
            zip: enteredAddress.zipcode,
            state: enteredAddress.state
          }), void 0)]
        }, void 0)
      }, void 0)
    }, void 0)]
  }, void 0);
}

function handleValidateAddress({
  values,
  confirmAddressToUse,
  addressKey
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;

  return __awaiter(this, void 0, void 0, function* () {
    // @ts-ignore
    const address = values[addressKey];

    try {
      const result = yield validateAddress({
        address1: address === null || address === void 0 ? void 0 : address.addressLine1,
        address2: address === null || address === void 0 ? void 0 : address.addressLine2,
        city: address === null || address === void 0 ? void 0 : address.city,
        zip: address === null || address === void 0 ? void 0 : address.zipcode,
        state: address === null || address === void 0 ? void 0 : address.state
      });
      const xmlJson = yield parseStringPromise(result.data);
      const addr = (_a = xmlJson === null || xmlJson === void 0 ? void 0 : xmlJson.AddressValidateResponse) === null || _a === void 0 ? void 0 : _a.Address[0];

      if (((_d = (_c = (_b = addr === null || addr === void 0 ? void 0 : addr.Error) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.Description) === null || _d === void 0 ? void 0 : _d[0]) === ERROR_INVALID_ZIP_CODE) {
        createConfirmation({
          variant: 'warning',
          children: ZIP_CORRECTION_MODAL,
          actions: [{
            label: 'Close',
            variant: 'primary',
            value: true
          }],
          callback: () => true
        });
        return; // if suggested address
      } else if (addr === null || addr === void 0 ? void 0 : addr.Address2) {
        const suggestedAddress = {
          // NOTE: ths is intentionall swapped because the USPS api returns
          // them swapped
          address2: (_e = addr === null || addr === void 0 ? void 0 : addr.Address1) === null || _e === void 0 ? void 0 : _e[0],
          address1: (_f = addr === null || addr === void 0 ? void 0 : addr.Address2) === null || _f === void 0 ? void 0 : _f[0],
          city: (_g = addr === null || addr === void 0 ? void 0 : addr.City) === null || _g === void 0 ? void 0 : _g[0],
          state: (_h = addr === null || addr === void 0 ? void 0 : addr.State) === null || _h === void 0 ? void 0 : _h[0],
          zip: (_j = addr === null || addr === void 0 ? void 0 : addr.Zip5) === null || _j === void 0 ? void 0 : _j[0]
        };
        createConfirmation({
          title: 'USPS Address Verification',
          className: 'address-modal',
          variant: 'warning',
          children: jsx(AddressConfirmationModal, Object.assign({}, {
            suggestedAddress,
            enteredAddress: address
          }), void 0),
          actions: [{
            label: 'Use Verified Address',
            variant: 'primary',
            value: 'usps'
          }, {
            label: 'Use Entered Address',
            variant: 'outline-primary',
            value: 'entered'
          }, {
            label: 'Edit Address',
            variant: 'link',
            value: 'close'
          }],
          callback: value => {
            // Use USPS address
            if (value === 'usps') {
              const updatedAddress = Object.assign(Object.assign({}, values[addressKey]), {
                addressLine1: suggestedAddress.address1,
                addressLine2: suggestedAddress.address2 || '',
                city: suggestedAddress.city,
                zipcode: suggestedAddress.zip,
                state: suggestedAddress.state,
                verification: 'verified'
              });
              confirmAddressToUse(Object.assign(Object.assign({}, values), {
                [addressKey]: updatedAddress
              }));
            } // Use Entered Address


            if (value === 'entered') {
              const updatedAddress = Object.assign(Object.assign({}, values[addressKey]), {
                verification: 'user-input'
              });
              confirmAddressToUse(Object.assign(Object.assign({}, values), {
                [addressKey]: updatedAddress
              }));
            } // Edit Address


            if (value === 'close') {
              return;
            }
          }
        });
      } else {
        createConfirmation({
          title: 'Cannot Verify Address',
          className: 'address-modal',
          variant: 'warning',
          children: jsx("p", {
            children: "The entered address cannot be verified."
          }, void 0),
          actions: [{
            label: 'Use Entered Address',
            variant: 'primary',
            value: 'entered'
          }],
          callback: () => {
            return;
          }
        });
      }
    } catch (err) {
      confirmAddressToUse(values);
    }
  });
}

function VAddressFields({
  addressKey = 'physicalAddress',
  countries,
  states = [],
  isUsOnly = false
}) {
  var _a;

  const form = useFormContext();
  const formValues = form.getValues();
  const [country, setCountry] = useState(((_a = formValues === null || formValues === void 0 ? void 0 : formValues[addressKey]) === null || _a === void 0 ? void 0 : _a.country) || '');

  const getIsDisabled = () => {
    const address = (formValues === null || formValues === void 0 ? void 0 : formValues[addressKey]) || {};

    if ((isUsOnly ? false : !address.country) || !address.addressLine1 || !address.city || !address.state || !address.zipcode) {
      return true;
    }

    return false;
  };

  const changeCountry = evt => {
    var _a;

    setCountry(((_a = evt === null || evt === void 0 ? void 0 : evt.target) === null || _a === void 0 ? void 0 : _a.value) || '');
  };

  const confirmAddressToUse = values => {
    form.reset(values);
  };

  const validateAddress = () => __awaiter(this, void 0, void 0, function* () {
    yield handleValidateAddress({
      values: formValues,
      confirmAddressToUse,
      addressKey
    });
  });

  return jsxs(Fragment, {
    children: [countries && !isUsOnly ? jsx(Row, {
      children: jsx(Col, {
        children: jsx(VSelectField, {
          name: `${addressKey}.country`,
          label: "Country",
          "data-testid": "country-select",
          options: countries,
          // @ts-ignore
          handleChange: changeCountry,
          required: true
        }, void 0)
      }, void 0)
    }, void 0) : null, jsx(Row, {
      children: jsx(Col, {
        children: jsx(VInputField, {
          name: `${addressKey}.addressLine1`,
          label: "Address Line 1",
          required: true
        }, void 0)
      }, void 0)
    }, void 0), jsx(Row, {
      children: jsx(Col, {
        children: jsx(VInputField, {
          name: `${addressKey}.addressLine2`,
          label: "Address Line 2"
        }, void 0)
      }, void 0)
    }, void 0), jsxs(Row, {
      children: [jsx(Col, {
        children: jsx(VInputField, {
          name: `${addressKey}.city`,
          label: "City or Town",
          required: true
        }, void 0)
      }, void 0), jsxs(Col, {
        children: [jsx(VOptional, Object.assign({
          show: country === 'US' || !country
        }, {
          children: jsx(VSelectField, {
            name: `${addressKey}.state`,
            label: "State",
            options: states,
            required: true
          }, void 0)
        }), void 0), jsx(VOptional, Object.assign({
          show: country !== 'US' && !!country
        }, {
          children: jsx(VInputField, {
            name: `${addressKey}.province`,
            label: "State/Province/Region",
            required: true
          }, void 0)
        }), void 0)]
      }, void 0), jsxs(Col, {
        children: [jsx(VOptional, Object.assign({
          show: country === 'US' || !country
        }, {
          children: jsx(VInputField, {
            name: `${addressKey}.zipcode`,
            label: "Zip Code",
            required: true
          }, void 0)
        }), void 0), jsx(VOptional, Object.assign({
          show: country !== 'US' && !!country
        }, {
          children: jsx(VInputField, {
            name: `${addressKey}.postalCode`,
            label: "Postal Code",
            required: true
          }, void 0)
        }), void 0)]
      }, void 0)]
    }, void 0), jsx(VInputField, {
      label: "Verification Field",
      name: `${addressKey}.verification`,
      type: "hidden",
      defaultValue: "unverified"
    }, void 0), jsx(VOptional, Object.assign({
      show: country === 'US' || !country
    }, {
      children: jsx(Row, Object.assign({
        className: "mt-3"
      }, {
        children: jsx(Col, {
          children: jsx(VButton, Object.assign({
            className: `${getIsDisabled() ? 'disabled' : ''}`,
            variant: "outline-primary",
            onClick: validateAddress,
            disabled: getIsDisabled(),
            "data-testid": "verify"
          }, {
            children: "Verify"
          }), void 0)
        }, void 0)
      }), void 0)
    }), void 0)]
  }, void 0);
}

const states = [{
  name: 'Alabama',
  id: 1,
  description: 'AL'
}, {
  name: 'Alaska',
  id: 2,
  description: 'AK'
}, {
  name: 'Arizona',
  id: 3,
  description: 'AZ'
}, {
  name: 'Arkansas',
  id: 4,
  description: 'AR'
}, {
  name: 'California',
  id: 5,
  description: 'CA'
}, {
  name: 'Colorado',
  id: 6,
  description: 'CO'
}, {
  name: 'Connecticut',
  id: 7,
  description: 'CT'
}, {
  name: 'Delaware',
  id: 8,
  description: 'DE'
}, {
  name: 'District of Columbia',
  id: 9,
  description: 'DC'
}, {
  name: 'Florida',
  id: 10,
  description: 'FL'
}, {
  name: 'Georgia',
  id: 11,
  description: 'GA'
}, {
  name: 'Hawaii',
  id: 12,
  description: 'HI'
}, {
  name: 'Idaho',
  id: 13,
  description: 'ID'
}, {
  name: 'Illinois',
  id: 14,
  description: 'IL'
}, {
  name: 'Indiana',
  id: 15,
  description: 'IN'
}, {
  name: 'Iowa',
  id: 16,
  description: 'IA'
}, {
  name: 'Kansas',
  id: 17,
  description: 'KS'
}, {
  name: 'Kentucky',
  id: 18,
  description: 'KY'
}, {
  name: 'Lousiana',
  id: 19,
  description: 'LA'
}, {
  name: 'Maine',
  id: 20,
  description: 'ME'
}, {
  name: 'Maryland',
  id: 21,
  description: 'MD'
}, {
  name: 'Massachusetts',
  id: 22,
  description: 'MA'
}, {
  name: 'Michigan',
  id: 23,
  description: 'MI'
}, {
  name: 'Minnesota',
  id: 24,
  description: 'MN'
}, {
  name: 'Mississippi',
  id: 25,
  description: 'MS'
}, {
  name: 'Missouri',
  id: 26,
  description: 'MO'
}, {
  name: 'Montana',
  id: 27,
  description: 'MT'
}, {
  name: 'Nebraska',
  id: 28,
  description: 'NE'
}, {
  name: 'Nevada',
  id: 29,
  description: 'NV'
}, {
  name: 'New Hampshire',
  id: 30,
  description: 'NH'
}, {
  name: 'New Jersey',
  id: 31,
  description: 'NJ'
}, {
  name: 'New Mexico',
  id: 32,
  description: 'NM'
}, {
  name: 'New York',
  id: 33,
  description: 'NY'
}, {
  name: 'North Carolina',
  id: 34,
  description: 'NC'
}, {
  name: 'North Dakota',
  id: 35,
  description: 'ND'
}, {
  name: 'Ohio',
  id: 36,
  description: 'OH'
}, {
  name: 'Oklahoma',
  id: 37,
  description: 'OK'
}, {
  name: 'Oregon',
  id: 38,
  description: 'OR'
}, {
  name: 'Pennsylvania',
  id: 39,
  description: 'PA'
}, {
  name: 'Rhode Island',
  id: 40,
  description: 'RI'
}, {
  name: 'South Carolina',
  id: 41,
  description: 'SC'
}, {
  name: 'South Dakota',
  id: 42,
  description: 'SD'
}, {
  name: 'Tennessee',
  id: 43,
  description: 'TN'
}, {
  name: 'Texas',
  id: 44,
  description: 'TX'
}, {
  name: 'Utah',
  id: 45,
  description: 'UT'
}, {
  name: 'Vermont',
  id: 46,
  description: 'VT'
}, {
  name: 'Virginia',
  id: 47,
  description: 'VA'
}, {
  name: 'Washington',
  id: 48,
  description: 'WA'
}, {
  name: 'West Virginia',
  id: 49,
  description: 'WV'
}, {
  name: 'Wisconsin',
  id: 50,
  description: 'WI'
}, {
  name: 'Wyoming',
  id: 51,
  description: 'WY'
}];

const countries = [{
  name: 'Afghanistan',
  id: 1,
  description: 'AF'
}, {
  name: 'Åland Islands',
  id: 2,
  description: 'AX'
}, {
  name: 'Albania',
  id: 3,
  description: 'AL'
}, {
  name: 'Algeria',
  id: 4,
  description: 'DZ'
}, {
  name: 'American Samoa',
  id: 5,
  description: 'AS'
}, {
  name: 'Andorra',
  id: 6,
  description: 'AD'
}, {
  name: 'Angola',
  id: 7,
  description: 'AO'
}, {
  name: 'Anguilla',
  id: 8,
  description: 'AI'
}, {
  name: 'Antarctica',
  id: 9,
  description: 'AQ'
}, {
  name: 'Antigua and Barbuda',
  id: 10,
  description: 'AG'
}, {
  name: 'Argentina',
  id: 11,
  description: 'AR'
}, {
  name: 'Armenia',
  id: 12,
  description: 'AM'
}, {
  name: 'Aruba',
  id: 13,
  description: 'AW'
}, {
  name: 'Australia',
  id: 14,
  description: 'AU'
}, {
  name: 'Austria',
  id: 15,
  description: 'AT'
}, {
  name: 'Azerbaijan',
  id: 16,
  description: 'AZ'
}, {
  name: 'Bahamas',
  id: 17,
  description: 'BS'
}, {
  name: 'Bahrain',
  id: 18,
  description: 'BH'
}, {
  name: 'Bangladesh',
  id: 19,
  description: 'BD'
}, {
  name: 'Barbados',
  id: 20,
  description: 'BB'
}, {
  name: 'Belarus',
  id: 21,
  description: 'BY'
}, {
  name: 'Belgium',
  id: 22,
  description: 'BE'
}, {
  name: 'Belize',
  id: 23,
  description: 'BZ'
}, {
  name: 'Benin',
  id: 24,
  description: 'BJ'
}, {
  name: 'Bermuda',
  id: 25,
  description: 'BM'
}, {
  name: 'Bhutan',
  id: 26,
  description: 'BT'
}, {
  name: 'Bolivia',
  id: 27,
  description: 'BO'
}, {
  name: 'Bosnia and Herzegovina',
  id: 28,
  description: 'BA'
}, {
  name: 'Botswana',
  id: 29,
  description: 'BW'
}, {
  name: 'Bouvet Island',
  id: 30,
  description: 'BV'
}, {
  name: 'Brazil',
  id: 31,
  description: 'BR'
}, {
  name: 'British Indian Ocean Territory',
  id: 32,
  description: 'IO'
}, {
  name: 'Brunei Darussalam',
  id: 33,
  description: 'BN'
}, {
  name: 'Bulgaria',
  id: 34,
  description: 'BG'
}, {
  name: 'Burkina Faso',
  id: 35,
  description: 'BF'
}, {
  name: 'Burundi',
  id: 36,
  description: 'BI'
}, {
  name: 'Cambodia',
  id: 37,
  description: 'KH'
}, {
  name: 'Cameroon',
  id: 38,
  description: 'CM'
}, {
  name: 'Canada',
  id: 39,
  description: 'CA'
}, {
  name: 'Cape Verde',
  id: 40,
  description: 'CV'
}, {
  name: 'Cayman Islands',
  id: 41,
  description: 'KY'
}, {
  name: 'Central African Republic',
  id: 42,
  description: 'CF'
}, {
  name: 'Chad',
  id: 43,
  description: 'TD'
}, {
  name: 'Chile',
  id: 44,
  description: 'CL'
}, {
  name: 'China',
  id: 45,
  description: 'CN'
}, {
  name: 'Christmas Island',
  id: 46,
  description: 'CX'
}, {
  name: 'Cocos (Keeling) Islands',
  id: 47,
  description: 'CC'
}, {
  name: 'Colombia',
  id: 48,
  description: 'CO'
}, {
  name: 'Comoros',
  id: 49,
  description: 'KM'
}, {
  name: 'Congo',
  id: 50,
  description: 'CG'
}, {
  name: 'Congo, The Democratic Republic of the',
  id: 51,
  description: 'CD'
}, {
  name: 'Cook Islands',
  id: 52,
  description: 'CK'
}, {
  name: 'Costa Rica',
  id: 53,
  description: 'CR'
}, {
  name: "Cote D'Ivoire",
  id: 54,
  description: 'CI'
}, {
  name: 'Croatia',
  id: 55,
  description: 'HR'
}, {
  name: 'Cuba',
  id: 56,
  description: 'CU'
}, {
  name: 'Cyprus',
  id: 57,
  description: 'CY'
}, {
  name: 'Czech Republic',
  id: 58,
  description: 'CZ'
}, {
  name: 'Denmark',
  id: 59,
  description: 'DK'
}, {
  name: 'Djibouti',
  id: 60,
  description: 'DJ'
}, {
  name: 'Dominica',
  id: 61,
  description: 'DM'
}, {
  name: 'Dominican Republic',
  id: 62,
  description: 'DO'
}, {
  name: 'Ecuador',
  id: 63,
  description: 'EC'
}, {
  name: 'Egypt',
  id: 64,
  description: 'EG'
}, {
  name: 'El Salvador',
  id: 65,
  description: 'SV'
}, {
  name: 'Equatorial Guinea',
  id: 66,
  description: 'GQ'
}, {
  name: 'Eritrea',
  id: 67,
  description: 'ER'
}, {
  name: 'Estonia',
  id: 68,
  description: 'EE'
}, {
  name: 'Ethiopia',
  id: 69,
  description: 'ET'
}, {
  name: 'Falkland Islands (Malvinas)',
  id: 70,
  description: 'FK'
}, {
  name: 'Faroe Islands',
  id: 71,
  description: 'FO'
}, {
  name: 'Fiji',
  id: 72,
  description: 'FJ'
}, {
  name: 'Finland',
  id: 73,
  description: 'FI'
}, {
  name: 'France',
  id: 74,
  description: 'FR'
}, {
  name: 'French Guiana',
  id: 75,
  description: 'GF'
}, {
  name: 'French Polynesia',
  id: 76,
  description: 'PF'
}, {
  name: 'French Southern Territories',
  id: 77,
  description: 'TF'
}, {
  name: 'Gabon',
  id: 78,
  description: 'GA'
}, {
  name: 'Gambia',
  id: 79,
  description: 'GM'
}, {
  name: 'Georgia',
  id: 80,
  description: 'GE'
}, {
  name: 'Germany',
  id: 81,
  description: 'DE'
}, {
  name: 'Ghana',
  id: 82,
  description: 'GH'
}, {
  name: 'Gibraltar',
  id: 83,
  description: 'GI'
}, {
  name: 'Greece',
  id: 84,
  description: 'GR'
}, {
  name: 'Greenland',
  id: 85,
  description: 'GL'
}, {
  name: 'Grenada',
  id: 86,
  description: 'GD'
}, {
  name: 'Guadeloupe',
  id: 87,
  description: 'GP'
}, {
  name: 'Guam',
  id: 88,
  description: 'GU'
}, {
  name: 'Guatemala',
  id: 89,
  description: 'GT'
}, {
  name: 'Guernsey',
  id: 90,
  description: 'GG'
}, {
  name: 'Guinea',
  id: 91,
  description: 'GN'
}, {
  name: 'Guinea-Bissau',
  id: 92,
  description: 'GW'
}, {
  name: 'Guyana',
  id: 93,
  description: 'GY'
}, {
  name: 'Haiti',
  id: 94,
  description: 'HT'
}, {
  name: 'Heard Island and Mcdonald Islands',
  id: 95,
  description: 'HM'
}, {
  name: 'Holy See (Vatican City State)',
  id: 96,
  description: 'VA'
}, {
  name: 'Honduras',
  id: 97,
  description: 'HN'
}, {
  name: 'Hong Kong',
  id: 98,
  description: 'HK'
}, {
  name: 'Hungary',
  id: 99,
  description: 'HU'
}, {
  name: 'Iceland',
  id: 100,
  description: 'IS'
}, {
  name: 'India',
  id: 101,
  description: 'IN'
}, {
  name: 'Indonesia',
  id: 102,
  description: 'ID'
}, {
  name: 'Iran, Islamic Republic Of',
  id: 103,
  description: 'IR'
}, {
  name: 'Iraq',
  id: 104,
  description: 'IQ'
}, {
  name: 'Ireland',
  id: 105,
  description: 'IE'
}, {
  name: 'Isle of Man',
  id: 106,
  description: 'IM'
}, {
  name: 'Israel',
  id: 107,
  description: 'IL'
}, {
  name: 'Italy',
  id: 108,
  description: 'IT'
}, {
  name: 'Jamaica',
  id: 109,
  description: 'JM'
}, {
  name: 'Japan',
  id: 110,
  description: 'JP'
}, {
  name: 'Jersey',
  id: 111,
  description: 'JE'
}, {
  name: 'Jordan',
  id: 112,
  description: 'JO'
}, {
  name: 'Kazakhstan',
  id: 113,
  description: 'KZ'
}, {
  name: 'Kenya',
  id: 114,
  description: 'KE'
}, {
  name: 'Kiribati',
  id: 115,
  description: 'KI'
}, {
  name: "Korea, Democratic People'S Republic of",
  id: 116,
  description: 'KP'
}, {
  name: 'Korea, Republic of',
  id: 117,
  description: 'KR'
}, {
  name: 'Kuwait',
  id: 118,
  description: 'KW'
}, {
  name: 'Kyrgyzstan',
  id: 119,
  description: 'KG'
}, {
  name: "Lao People'S Democratic Republic",
  id: 120,
  description: 'LA'
}, {
  name: 'Latvia',
  id: 121,
  description: 'LV'
}, {
  name: 'Lebanon',
  id: 122,
  description: 'LB'
}, {
  name: 'Lesotho',
  id: 123,
  description: 'LS'
}, {
  name: 'Liberia',
  id: 124,
  description: 'LR'
}, {
  name: 'Libyan Arab Jamahiriya',
  id: 125,
  description: 'LY'
}, {
  name: 'Liechtenstein',
  id: 126,
  description: 'LI'
}, {
  name: 'Lithuania',
  id: 127,
  description: 'LT'
}, {
  name: 'Luxembourg',
  id: 128,
  description: 'LU'
}, {
  name: 'Macao',
  id: 129,
  description: 'MO'
}, {
  name: 'Macedonia, The Former Yugoslav Republic of',
  id: 130,
  description: 'MK'
}, {
  name: 'Madagascar',
  id: 131,
  description: 'MG'
}, {
  name: 'Malawi',
  id: 132,
  description: 'MW'
}, {
  name: 'Malaysia',
  id: 133,
  description: 'MY'
}, {
  name: 'Maldives',
  id: 134,
  description: 'MV'
}, {
  name: 'Mali',
  id: 135,
  description: 'ML'
}, {
  name: 'Malta',
  id: 136,
  description: 'MT'
}, {
  name: 'Marshall Islands',
  id: 137,
  description: 'MH'
}, {
  name: 'Martinique',
  id: 138,
  description: 'MQ'
}, {
  name: 'Mauritania',
  id: 139,
  description: 'MR'
}, {
  name: 'Mauritius',
  id: 140,
  description: 'MU'
}, {
  name: 'Mayotte',
  id: 141,
  description: 'YT'
}, {
  name: 'Mexico',
  id: 142,
  description: 'MX'
}, {
  name: 'Micronesia, Federated States of',
  id: 143,
  description: 'FM'
}, {
  name: 'Moldova, Republic of',
  id: 144,
  description: 'MD'
}, {
  name: 'Monaco',
  id: 145,
  description: 'MC'
}, {
  name: 'Mongolia',
  id: 146,
  description: 'MN'
}, {
  name: 'Montserrat',
  id: 147,
  description: 'MS'
}, {
  name: 'Morocco',
  id: 148,
  description: 'MA'
}, {
  name: 'Mozambique',
  id: 149,
  description: 'MZ'
}, {
  name: 'Myanmar',
  id: 150,
  description: 'MM'
}, {
  name: 'Namibia',
  id: 151,
  description: 'NA'
}, {
  name: 'Nauru',
  id: 152,
  description: 'NR'
}, {
  name: 'Nepal',
  id: 153,
  description: 'NP'
}, {
  name: 'Netherlands',
  id: 154,
  description: 'NL'
}, {
  name: 'Netherlands Antilles',
  id: 155,
  description: 'AN'
}, {
  name: 'New Caledonia',
  id: 156,
  description: 'NC'
}, {
  name: 'New Zealand',
  id: 157,
  description: 'NZ'
}, {
  name: 'Nicaragua',
  id: 158,
  description: 'NI'
}, {
  name: 'Niger',
  id: 159,
  description: 'NE'
}, {
  name: 'Nigeria',
  id: 160,
  description: 'NG'
}, {
  name: 'Niue',
  id: 161,
  description: 'NU'
}, {
  name: 'Norfolk Island',
  id: 162,
  description: 'NF'
}, {
  name: 'Northern Mariana Islands',
  id: 163,
  description: 'MP'
}, {
  name: 'Norway',
  id: 164,
  description: 'NO'
}, {
  name: 'Oman',
  id: 165,
  description: 'OM'
}, {
  name: 'Pakistan',
  id: 166,
  description: 'PK'
}, {
  name: 'Palau',
  id: 167,
  description: 'PW'
}, {
  name: 'Palestinian Territory, Occupied',
  id: 168,
  description: 'PS'
}, {
  name: 'Panama',
  id: 169,
  description: 'PA'
}, {
  name: 'Papua New Guinea',
  id: 170,
  description: 'PG'
}, {
  name: 'Paraguay',
  id: 171,
  description: 'PY'
}, {
  name: 'Peru',
  id: 172,
  description: 'PE'
}, {
  name: 'Philippines',
  id: 173,
  description: 'PH'
}, {
  name: 'Pitcairn',
  id: 174,
  description: 'PN'
}, {
  name: 'Poland',
  id: 175,
  description: 'PL'
}, {
  name: 'Portugal',
  id: 176,
  description: 'PT'
}, {
  name: 'Puerto Rico',
  id: 177,
  description: 'PR'
}, {
  name: 'Qatar',
  id: 178,
  description: 'QA'
}, {
  name: 'Reunion',
  id: 179,
  description: 'RE'
}, {
  name: 'Romania',
  id: 180,
  description: 'RO'
}, {
  name: 'Russian Federation',
  id: 181,
  description: 'RU'
}, {
  name: 'RWANDA',
  id: 182,
  description: 'RW'
}, {
  name: 'Saint Helena',
  id: 183,
  description: 'SH'
}, {
  name: 'Saint Kitts and Nevis',
  id: 184,
  description: 'KN'
}, {
  name: 'Saint Lucia',
  id: 185,
  description: 'LC'
}, {
  name: 'Saint Pierre and Miquelon',
  id: 186,
  description: 'PM'
}, {
  name: 'Saint Vincent and the Grenadines',
  id: 187,
  description: 'VC'
}, {
  name: 'Samoa',
  id: 188,
  description: 'WS'
}, {
  name: 'San Marino',
  id: 189,
  description: 'SM'
}, {
  name: 'Sao Tome and Principe',
  id: 190,
  description: 'ST'
}, {
  name: 'Saudi Arabia',
  id: 191,
  description: 'SA'
}, {
  name: 'Senegal',
  id: 192,
  description: 'SN'
}, {
  name: 'Serbia and Montenegro',
  id: 193,
  description: 'CS'
}, {
  name: 'Seychelles',
  id: 194,
  description: 'SC'
}, {
  name: 'Sierra Leone',
  id: 195,
  description: 'SL'
}, {
  name: 'Singapore',
  id: 196,
  description: 'SG'
}, {
  name: 'Slovakia',
  id: 197,
  description: 'SK'
}, {
  name: 'Slovenia',
  id: 198,
  description: 'SI'
}, {
  name: 'Solomon Islands',
  id: 199,
  description: 'SB'
}, {
  name: 'Somalia',
  id: 200,
  description: 'SO'
}, {
  name: 'South Africa',
  id: 201,
  description: 'ZA'
}, {
  name: 'South Georgia and the South Sandwich Islands',
  id: 202,
  description: 'GS'
}, {
  name: 'Spain',
  id: 203,
  description: 'ES'
}, {
  name: 'Sri Lanka',
  id: 204,
  description: 'LK'
}, {
  name: 'Sudan',
  id: 205,
  description: 'SD'
}, {
  name: 'Suriname',
  id: 206,
  description: 'SR'
}, {
  name: 'Svalbard and Jan Mayen',
  id: 207,
  description: 'SJ'
}, {
  name: 'Swaziland',
  id: 208,
  description: 'SZ'
}, {
  name: 'Sweden',
  id: 209,
  description: 'SE'
}, {
  name: 'Switzerland',
  id: 210,
  description: 'CH'
}, {
  name: 'Syrian Arab Republic',
  id: 211,
  description: 'SY'
}, {
  name: 'Taiwan, Province of China',
  id: 212,
  description: 'TW'
}, {
  name: 'Tajikistan',
  id: 213,
  description: 'TJ'
}, {
  name: 'Tanzania, United Republic of',
  id: 214,
  description: 'TZ'
}, {
  name: 'Thailand',
  id: 215,
  description: 'TH'
}, {
  name: 'Timor-Leste',
  id: 216,
  description: 'TL'
}, {
  name: 'Togo',
  id: 217,
  description: 'TG'
}, {
  name: 'Tokelau',
  id: 218,
  description: 'TK'
}, {
  name: 'Tonga',
  id: 219,
  description: 'TO'
}, {
  name: 'Trinidad and Tobago',
  id: 220,
  description: 'TT'
}, {
  name: 'Tunisia',
  id: 221,
  description: 'TN'
}, {
  name: 'Turkey',
  id: 222,
  description: 'TR'
}, {
  name: 'Turkmenistan',
  id: 223,
  description: 'TM'
}, {
  name: 'Turks and Caicos Islands',
  id: 224,
  description: 'TC'
}, {
  name: 'Tuvalu',
  id: 225,
  description: 'TV'
}, {
  name: 'Uganda',
  id: 226,
  description: 'UG'
}, {
  name: 'Ukraine',
  id: 227,
  description: 'UA'
}, {
  name: 'United Arab Emirates',
  id: 228,
  description: 'AE'
}, {
  name: 'United Kingdom',
  id: 229,
  description: 'GB'
}, {
  name: 'United States',
  id: 230,
  description: 'US'
}, {
  name: 'United States Minor Outlying Islands',
  id: 231,
  description: 'UM'
}, {
  name: 'Uruguay',
  id: 232,
  description: 'UY'
}, {
  name: 'Uzbekistan',
  id: 233,
  description: 'UZ'
}, {
  name: 'Vanuatu',
  id: 234,
  description: 'VU'
}, {
  name: 'Venezuela',
  id: 235,
  description: 'VE'
}, {
  name: 'Viet Nam',
  id: 236,
  description: 'VN'
}, {
  name: 'Virgin Islands, British',
  id: 237,
  description: 'VG'
}, {
  name: 'Virgin Islands, U.S.',
  id: 238,
  description: 'VI'
}, {
  name: 'Wallis and Futuna',
  id: 239,
  description: 'WF'
}, {
  name: 'Western Sahara',
  id: 240,
  description: 'EH'
}, {
  name: 'Yemen',
  id: 241,
  description: 'YE'
}, {
  name: 'Zambia',
  id: 242,
  description: 'ZM'
}, {
  name: 'Zimbabwe',
  id: 243,
  description: 'ZW'
}];

function getGroupIds(field, groupId) {
  const id = `${field}-id`;
  const helpId = `${groupId}-help`;
  const errorId = `${groupId}-error`;
  const alertErrorId = `${id}-alert-error`;
  return {
    id,
    helpId,
    errorId,
    alertErrorId
  };
}

function RawVFieldsetWrapper(props) {
  const {
    id,
    legend,
    required,
    helpId,
    helpText,
    errorId,
    error,
    hasErrors,
    hasAlertError,
    alertErrorId,
    children,
    label
  } = props;
  return jsx(Form.Group, {
    children: jsxs("fieldset", Object.assign({
      id: id
    }, {
      children: [legend && jsxs("legend", Object.assign({
        "data-testid": "fieldset-legend"
      }, {
        children: [legend, required && jsx("span", Object.assign({
          className: "vstart-required"
        }, {
          children: " *"
        }), void 0)]
      }), void 0), jsx("label", {
        children: label
      }, void 0), jsx("p", {
        children: jsx(VFieldHelpText, Object.assign({}, {
          helpId,
          helpText
        }), void 0)
      }, void 0), children, jsx("div", {
        className: classnames({
          'd-none': !hasErrors,
          'is-invalid': hasErrors
        })
      }, void 0), jsx(VFieldError, Object.assign({}, {
        errorId,
        error,
        hasErrors
      }), void 0), jsx(VFieldReturnToError, Object.assign({}, {
        hasAlertError,
        alertErrorId
      }), void 0)]
    }), void 0)
  }, void 0);
}

function VFieldsetWrapper(props) {
  const {
    groupId = 'group-id',
    fields
  } = props;
  let name = groupId;

  if (fields.length === 1) {
    name = fields[0];
  }

  const fieldIds = getGroupIds(name, groupId);
  const hasAlertError = useGetAlertRef(name);
  return jsx(RawVFieldsetWrapper, Object.assign({}, Object.assign(Object.assign(Object.assign({}, props), fieldIds), {
    hasAlertError: hasAlertError()
  })), void 0);
}

function useAddAlertRef(name) {
  var _a;

  const alertIds = useContext(VFormContext);
  (_a = alertIds === null || alertIds === void 0 ? void 0 : alertIds.current) === null || _a === void 0 ? void 0 : _a.add(name);
}

function VButtonRadioInner(props) {
  const {
    id,
    name,
    errorId,
    register,
    helpId,
    helpText,
    hasErrors,
    label,
    checked,
    value,
    inline
  } = props;
  const inputId = `${id}-input`;
  const className = checked ? 'btn-dark' : 'btn-outline-primary';
  const describedBy = classnames({
    [helpId]: !!helpText,
    [errorId]: hasErrors
  });
  return jsxs(Form.Check, Object.assign({
    className: "mb-2"
  }, {
    inline
  }, {
    children: [jsx(Form.Check.Input, Object.assign({}, Object.assign(Object.assign({
      id: inputId,
      name,
      value
    }, register(name)), {
      type: 'radio',
      className: 'visually-hidden',
      'aria-describedby': describedBy || undefined
    })), void 0), jsx(Form.Check.Label, Object.assign({}, {
      id: `${id}-label`,
      htmlFor: inputId
    }, {
      children: jsx("div", Object.assign({
        id: `${id}-button`,
        className: `btn btn-sm d-flex align-items-center ${className} mb-1 me-1`
      }, {
        children: label
      }), void 0)
    }), void 0)]
  }), void 0);
}

function VButtonRadio(props) {
  const {
    name,
    groupId,
    label,
    helpText,
    inline = false
  } = props;
  const {
    register,
    error,
    hasErrors,
    value
  } = useVFormContext(name);
  const {
    id,
    helpId,
    errorId
  } = getGroupIds(`${name}-${props.value}`, groupId);
  const checked = value === props.value;
  return jsx(VButtonRadioInner, Object.assign({}, {
    name,
    id,
    errorId,
    register,
    helpId,
    helpText,
    hasErrors,
    error,
    label,
    checked,
    value: props.value,
    inline
  }), void 0);
}

function VButtonRadioGroup(props) {
  const {
    groupId,
    legend,
    name,
    helpText,
    options,
    required,
    inline = false
  } = props;
  const updatedGroupId = groupId ? groupId : `${name}-group-id`;
  const {
    error,
    hasErrors
  } = useVFormContext(name);
  return jsx(VFieldsetWrapper, Object.assign({}, {
    groupId: updatedGroupId,
    fields: [name],
    legend,
    helpText,
    error,
    hasErrors,
    required
  }, {
    children: jsx("div", Object.assign({
      className: "pt-4"
    }, {
      children: options.length ? options.map(option => jsx(VButtonRadio, Object.assign({}, {
        groupId: updatedGroupId,
        key: option.value,
        name,
        label: option.label,
        value: option.value,
        helpText,
        inline
      }), void 0)) : jsx(VLoader, {}, void 0)
    }), void 0)
  }), void 0);
}

var $$4 = _export;
var $includes = arrayIncludes.includes;
var fails$1 = fails$i;
var addToUnscopables = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$1(function () {
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$4({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var isObject = isObject$6;
var classof$1 = classofRaw$1;
var wellKnownSymbol$1 = wellKnownSymbol$c;

var MATCH$1 = wellKnownSymbol$1('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$1(it) == 'RegExp');
};

var global$2 = global$w;
var isRegExp = isRegexp;

var TypeError$1 = global$2.TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw TypeError$1("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol = wellKnownSymbol$c;

var MATCH = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$3 = _export;
var uncurryThis$3 = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible$2 = requireObjectCoercible$7;
var toString$3 = toString$7;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf = uncurryThis$3(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$3({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString$3(requireObjectCoercible$2(this)),
      toString$3(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

library.add(faCheckSquare, faSquare);
function VCheckbox(props) {
  const {
    id,
    name,
    errorId,
    register,
    helpId,
    helpText,
    hasErrors,
    label,
    checked,
    value,
    required,
    disabled
  } = props;
  const inputId = `${id}-input`;
  const icon = checked ? 'check-square' : 'square';
  const describedBy = classnames({
    [helpId]: !!helpText,
    [errorId]: hasErrors
  });
  return jsxs(Form.Check, {
    children: [jsx(Form.Check.Input, Object.assign({}, Object.assign(Object.assign({
      id: inputId,
      name,
      value,
      disabled,
      role: 'checkbox'
    }, register(name)), {
      type: 'checkbox',
      className: 'visually-hidden',
      'aria-describedby': describedBy || undefined
    })), void 0), jsxs(Form.Check.Label, Object.assign({}, {
      id: `${id}-label`,
      htmlFor: inputId
    }, {
      className: "d-flex"
    }, {
      children: [jsx(FontAwesomeIcon, {
        id: `${id}-icon`,
        icon: icon,
        className: "vstart-input-icon"
      }, void 0), jsxs("span", {
        children: [label, required && jsx("span", Object.assign({
          className: "vstart-required"
        }, {
          children: " *"
        }), void 0)]
      }, void 0)]
    }), void 0)]
  }, void 0);
}

function VCheckboxInner(props) {
  const {
    groupId,
    label,
    helpText,
    name
  } = props;
  const {
    register,
    error,
    hasErrors,
    value
  } = useVFormContext(name);
  const {
    id,
    helpId,
    errorId
  } = getGroupIds(props.value ? `${name}-${props.value}` : `${name}`, groupId);
  const checked = Array.isArray(value) ? value.includes(props.value) : value;
  return jsx(VCheckbox, Object.assign({}, {
    name,
    id,
    errorId,
    register,
    helpId,
    helpText,
    hasErrors,
    error,
    label,
    checked,
    required: props.required,
    value: props.value,
    disabled: props.disabled
  }), void 0);
}

function VCheckboxField(props) {
  const {
    name,
    helpText
  } = props;

  const {
    legend,
    required
  } = props,
        innerProps = __rest(props, ["legend", "required"]);

  const {
    error,
    hasErrors
  } = useVFormContext(name);
  const updatedGroupId = `${name}-group-id`;
  return jsx(VFieldsetWrapper, Object.assign({}, {
    groupId: updatedGroupId,
    fields: [name],
    legend,
    error,
    hasErrors,
    required,
    helpText
  }, {
    children: jsx(VCheckboxInner, Object.assign({}, innerProps, {
      required: required,
      groupId: updatedGroupId
    }), void 0)
  }), void 0);
}

function VCheckboxGroupField(props) {
  const {
    groupId,
    legend,
    label,
    helpText,
    name,
    options,
    required
  } = props;
  const updatedGroupId = groupId ? groupId : `${name}-group-id`;
  const {
    error,
    hasErrors
  } = useVFormContext(name);
  return jsx(VFieldsetWrapper, Object.assign({}, {
    groupId: updatedGroupId,
    fields: [name],
    legend,
    required,
    helpText,
    label,
    error,
    hasErrors
  }, {
    children: options.map(option => jsx(VCheckboxInner, Object.assign({}, {
      groupId: updatedGroupId,
      key: option.value,
      name,
      label: option.label,
      value: option.value,
      disabled: option.disabled,
      helpText
    }), void 0))
  }), void 0);
}

function VDateField(props) {
  const {
    name,
    isLabelHidden,
    label
  } = props;

  const {
    required,
    helpText,
    appendIcon
  } = props,
        inputProps = __rest(props, ["required", "helpText", "appendIcon"]);

  const {
    register,
    error,
    hasErrors
  } = useVFormContext(name);
  const {
    id,
    helpId,
    errorId
  } = getFieldIds(name);
  const describedBy = classnames({
    [helpId]: !!helpText,
    [errorId]: hasErrors
  });
  return jsx(VFieldWrapper, Object.assign({}, Object.assign(Object.assign({}, props), {
    hasErrors,
    error
  }), {
    children: jsx(InputGroup, Object.assign({
      className: classnames('vstart-date-field-input-group', {
        'is-invalid': hasErrors
      })
    }, {
      children: jsx(Form.Control, Object.assign({}, Object.assign(Object.assign(Object.assign(Object.assign({}, inputProps), {
        type: 'date',
        id,
        invalid: hasErrors ? 'true' : 'false'
      }), register(name)), {
        isInvalid: hasErrors,
        onChange: inputProps.handleChange,
        'aria-label': isLabelHidden ? undefined : label,
        'aria-describedby': describedBy || undefined
      }), {
        "data-testid": `date-field-${id}`
      }), void 0)
    }), void 0)
  }), void 0);
}
VDateField.defaultProps = {
  appendIcon: true
};

function VFileUploadField(props) {
  const {
    accept,
    name,
    hintText,
    required,
    helpText,
    label
  } = props,
        inputProps = __rest(props, ["accept", "name", "hintText", "required", "helpText", "label"]);

  const {
    register,
    error,
    hasErrors,
    setValue,
    value
  } = useVFormContext(name, label);
  const {
    id,
    helpId,
    errorId
  } = getFieldIds(name);
  const alternateLabelId = `alternate-label-${id}`;

  const getInput = () => {
    if (value && value[0]) {
      return jsxs(Fragment$1, {
        children: [jsx("label", Object.assign({
          className: "custom-file-label me-4",
          id: alternateLabelId
        }, {
          children: value[0].name
        }), void 0), jsx("button", Object.assign({
          className: "vstart-file-upload-clear",
          "data-testid": "vstart-file-upload-clear",
          onClick: () => setValue(name, undefined)
        }, {
          children: jsx(FontAwesomeIcon, {
            id: "clear-icon",
            icon: "times-circle",
            size: "sm"
          }, void 0)
        }), void 0)]
      }, void 0);
    }

    return jsx("label", Object.assign({
      className: "custom-file-label",
      id: alternateLabelId
    }, {
      children: FILE_UPLOAD_PLACEHOLDER
    }), void 0);
  };

  return jsxs(VFieldWrapper, Object.assign({}, Object.assign(Object.assign({}, props), {
    hasErrors,
    error
  }), {
    children: [jsxs("div", Object.assign({
      className: "custom-file vstart-file-upload-field"
    }, {
      children: [jsx(Form.Control, Object.assign({}, Object.assign(Object.assign(Object.assign(Object.assign({}, inputProps), {
        id,
        invalid: hasErrors ? 'true' : 'false',
        isInvalid: hasErrors
      }), register(name)), {
        type: 'file',
        className: 'custom-file-input',
        accept
      }), {
        "data-testid": `input-field-${id}`,
        "aria-describedby": classnames(alternateLabelId, {
          [helpId]: !!helpText,
          [errorId]: hasErrors
        })
      }), void 0), getInput()]
    }), void 0), hintText && jsx(Form.Text, Object.assign({
      className: "vstart-hint-text"
    }, {
      children: hintText
    }), void 0)]
  }), void 0);
}

var classof = classofRaw$1;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es-x/no-array-isarray -- safe
var isArray$1 = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};

var $$2 = _export;
var uncurryThis$2 = functionUncurryThis;
var isArray = isArray$1;

var un$Reverse = uncurryThis$2([].reverse);
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$$2({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return un$Reverse(this);
  }
});

const formatName = person => {
  const {
    firstName,
    lastName,
    nickname,
    reverse = false
  } = person || {};

  if (firstName && lastName && nickname) {
    if (reverse) {
      return `${lastName}, ${firstName} - ${nickname}`;
    }

    return `${firstName} ${lastName} - ${nickname}`;
  }

  if (firstName && lastName) {
    if (reverse) {
      return `${lastName}, ${firstName}`;
    }

    return `${firstName} ${lastName}`;
  }

  if (firstName && !lastName) {
    return firstName;
  }

  if (lastName) {
    return lastName;
  }

  return NO_NAME_PROVIDED;
};

function VAlert(props) {
  const {
    showAlert,
    setShowAlert,
    variant,
    heading,
    isGlobalAlert = false,
    children,
    className = '',
    showIcon = true
  } = props;
  const ref = useRef(null);
  const alertIcon = getAlertIcon(variant);
  useEffect(() => {
    var _a;

    if (showAlert) {
      window.scrollTo(0, ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.offsetTop) || 0);
    }
  }, [showAlert]);

  const onClose = () => {
    setShowAlert === null || setShowAlert === void 0 ? void 0 : setShowAlert(false);
  };

  return jsxs(Alert, Object.assign({
    variant: variant,
    ref: ref,
    className: classnames(`vstart-alert vstart-alert-${variant}`, className, {
      'd-none': !showAlert
    }),
    onClose: onClose,
    dismissible: !!setShowAlert
  }, isGlobalAlert ? {} : {
    role: 'alert'
  }, {
    "data-testid": `alert-${variant}`
  }, {
    children: [heading ? jsx(Alert.Heading, {
      children: heading
    }, void 0) : null, alertIcon && showIcon ? jsx(FontAwesomeIcon, {
      id: `${variant}-icon`,
      icon: alertIcon,
      className: `vstart-alert-icon`,
      "data-testid": "alert-icon",
      "aria-label": `alert-${variant}-icon`
    }, void 0) : null, children]
  }), void 0);
}

function VFormAlertLink(props) {
  const {
    field,
    error,
    fieldNamePretty
  } = props;
  const {
    id: fieldId,
    alertErrorId: id
  } = getFieldIds(field);
  useAddAlertRef(field);
  return jsxs("li", Object.assign({
    id: id
  }, {
    children: [jsx(Link, Object.assign({
      to: `#${fieldId}`
    }, {
      children: fieldNamePretty || field
    }), void 0), ": ", error]
  }), void 0);
}

function VFormAlert(props) {
  const {
    errors = []
  } = props;
  const fieldErrors = errors.map(error => jsx(VFormAlertLink, Object.assign({}, Object.assign({
    key: error.field
  }, error)), void 0));
  return jsx(VAlert, Object.assign({
    variant: "danger",
    showAlert: !!fieldErrors.length,
    heading: "Form Errors"
  }, {
    children: jsx("ul", {
      children: fieldErrors
    }, void 0)
  }), void 0);
}

function VPageTitle(props) {
  const {
    id,
    title,
    editLink,
    pill,
    downsizeHeader
  } = props;
  return jsxs(Fragment$1, {
    children: [jsxs("div", Object.assign({
      className: "d-flex align-items-center mb-3"
    }, {
      children: [downsizeHeader ? jsx("h2", Object.assign({
        id: id,
        className: "pe-3 pt-2"
      }, {
        children: title
      }), void 0) : jsx("h1", Object.assign({
        id: id,
        className: "pe-3"
      }, {
        children: title
      }), void 0), editLink, pill]
    }), void 0), jsx("hr", {}, void 0)]
  }, void 0);
}

function VFormLayout(props) {
  const {
    title,
    titleId,
    children,
    help,
    buttons,
    hideHelp = false,
    pill,
    downsizeHeader
  } = props;
  return jsxs(Fragment, {
    children: [jsx(Row, {
      children: jsx(Col, {
        children: jsx(VPageTitle, {
          id: titleId,
          title: title,
          pill: pill,
          downsizeHeader: downsizeHeader
        }, void 0)
      }, void 0)
    }, void 0), jsxs(Row, {
      children: [jsx(Col, {
        children: children
      }, void 0), !hideHelp && help ? jsx(Col, Object.assign({
        xs: true,
        lg: 3,
        md: 5
      }, {
        children: help
      }), void 0) : null]
    }, void 0), jsx("hr", {}, void 0), buttons]
  }, void 0);
}

var $$1 = _export;
var DESCRIPTORS = descriptors;
var global$1 = global$w;
var uncurryThis$1 = functionUncurryThis;
var hasOwn = hasOwnProperty_1;
var isCallable = isCallable$i;
var isPrototypeOf = objectIsPrototypeOf;
var toString$2 = toString$7;
var defineProperty = objectDefineProperty.f;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$1.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString$2(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var symbolToString = uncurryThis$1(SymbolPrototype.toString);
  var symbolValueOf = uncurryThis$1(SymbolPrototype.valueOf);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace$1 = uncurryThis$1(''.replace);
  var stringSlice = uncurryThis$1(''.slice);

  defineProperty(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = symbolValueOf(this);
      var string = symbolToString(symbol);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace$1(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$1({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

function VIconButtonRadio(props) {
  const {
    id,
    icon,
    description,
    name,
    errorId,
    register,
    helpId,
    helpText,
    hasErrors,
    label,
    checked,
    value,
    inline,
    disabled
  } = props;
  const inputId = `${id}-input`;
  const className = classnames({
    selected: checked,
    disabled: disabled
  });
  const describedBy = classnames({
    [helpId]: !!helpText,
    [errorId]: hasErrors
  });
  return jsxs(Form.Check, Object.assign({
    className: "mb-2"
  }, {
    inline
  }, {
    children: [jsx(Form.Check.Input, Object.assign({}, Object.assign(Object.assign({
      id: inputId,
      value
    }, register(name)), {
      type: 'radio',
      className: 'visually-hidden',
      disabled,
      'data-testid': inputId,
      'aria-describedby': describedBy || undefined
    })), void 0), jsx(Form.Check.Label, Object.assign({}, {
      id: `${id}-label`,
      htmlFor: inputId
    }, {
      children: jsxs("div", Object.assign({
        id: `${id}-button`,
        className: `btn ${className} vstart-icon-button`
      }, {
        children: [jsx(FontAwesomeIcon, {
          icon: icon,
          size: "3x",
          className: "mb-2"
        }, void 0), jsx("p", Object.assign({
          "data-testid": "icon-label",
          className: "icon-label"
        }, {
          children: label
        }), void 0), jsx("p", {
          "data-testid": "icon-description",
          className: "icon-description",
          dangerouslySetInnerHTML: {
            __html: description
          }
        }, void 0)]
      }), void 0)
    }), void 0)]
  }), void 0);
}

function VIconButtonRadioInner(props) {
  const {
    name,
    groupId,
    label,
    helpText,
    description,
    icon,
    disabled,
    inline = false
  } = props;
  const {
    register,
    error,
    hasErrors,
    value
  } = useVFormContext(name);
  const {
    id,
    helpId,
    errorId
  } = getGroupIds(`${name}-${props.value}`, groupId);
  const checked = value === props.value;
  return jsx(VIconButtonRadio, Object.assign({}, {
    name,
    id,
    errorId,
    register,
    helpId,
    helpText,
    hasErrors,
    error,
    label,
    checked,
    value: props.value,
    inline,
    description,
    icon,
    disabled
  }), void 0);
}

function VIconButtonRadioGroup(props) {
  const {
    groupId,
    legend,
    name,
    helpText,
    options,
    required,
    inline = false
  } = props;
  const updatedGroupId = groupId ? groupId : `${name}-group-id`;
  const {
    error,
    hasErrors
  } = useVFormContext(name);
  return jsx(VFieldsetWrapper, Object.assign({}, {
    groupId: updatedGroupId,
    fields: [name],
    legend,
    helpText,
    error,
    hasErrors,
    required
  }, {
    children: options.length ? options.map(option => jsx(VIconButtonRadioInner, Object.assign({}, {
      groupId: updatedGroupId,
      key: option.value,
      name,
      label: option.label,
      value: option.value,
      description: option.description,
      icon: option.icon,
      helpText,
      inline,
      disabled: option.disabled
    }), void 0)) : jsx(VLoader, {}, void 0)
  }), void 0);
}

library.add(faDotCircle, faCircle);
function VRadio(props) {
  const {
    id,
    name,
    errorId,
    disabled,
    register,
    helpId,
    helpText,
    hasErrors,
    label,
    isChecked,
    value,
    handleChange
  } = props;
  const inputId = `${id}-input`;
  const describedBy = classnames({
    [helpId]: !!helpText,
    [errorId]: hasErrors
  });

  const radioChange = item => {
    handleChange && handleChange(item);
  };

  return jsx(Form.Check, Object.assign({}, Object.assign(Object.assign({
    id: inputId,
    name,
    disabled,
    value
  }, register(name)), {
    type: 'radio',
    'aria-describedby': describedBy || undefined,
    'data-testid': inputId,
    label,
    checked: isChecked,
    onChange: radioChange
  })), void 0);
}

function VRadioInner(props) {
  const {
    name,
    groupId,
    label,
    helpText,
    disabled,
    handleChange
  } = props;
  const {
    register,
    error,
    hasErrors,
    value,
    setValue
  } = useVFormContext(name);

  const radioClick = () => {
    setValue(name, props.value);
    handleChange && handleChange({
      value: props.value
    });
  };

  const {
    id,
    helpId,
    errorId
  } = getGroupIds(`${name}-${props.value}`, groupId);
  const isChecked = value === props.value;
  return jsx(VRadio, Object.assign({}, {
    name,
    id,
    errorId,
    register,
    helpId,
    helpText,
    hasErrors,
    error,
    disabled,
    label,
    isChecked,
    value: props.value,
    handleChange: radioClick
  }), void 0);
}

function VRadioGroupField(props) {
  const {
    groupId,
    legend,
    name,
    helpText,
    options,
    required,
    handleChange
  } = props;
  const updatedGroupId = groupId ? groupId : `${name}-group-id`;
  const {
    error,
    hasErrors,
    setValue
  } = useVFormContext(name);
  useEffect(() => {
    const option = options.find(({
      isChecked
    }) => isChecked);

    if (option) {
      setValue(name, option.value);
    }
  }, [name, options, setValue]);

  const radioClick = option => {
    setValue(name, option.value);
    handleChange && handleChange(option);
  };

  return jsx(VFieldsetWrapper, Object.assign({}, {
    groupId: updatedGroupId,
    fields: [name],
    legend,
    helpText,
    error,
    hasErrors,
    required,
    label: props.label
  }, {
    children: options.map(option => jsx(VRadioInner, Object.assign({}, {
      groupId: updatedGroupId,
      key: option.value,
      name,
      label: option.label,
      value: option.value,
      helpText,
      disabled: option.disabled,
      handleChange: () => radioClick(option)
    }), void 0))
  }), void 0);
}

function VRequiredFieldsText() {
  const beforeText = 'All fields marked with a red asterisk ';
  const afterText = 'are required. While not all fields are required, please fill out each question as accurately as possible.';
  return jsx("div", Object.assign({
    className: "mb-4"
  }, {
    children: jsxs("span", {
      children: [beforeText, jsx("span", Object.assign({
        className: "vstart-red-asterisk"
      }, {
        children: " * "
      }), void 0), afterText]
    }, void 0)
  }), void 0);
}

function VTextAreaField(props) {
  var _a;

  const [value, setValue] = useState('');
  const {
    name,
    label
  } = props;

  const {
    required,
    helpText,
    maxLength
  } = props,
        inputProps = __rest(props, ["required", "helpText", "maxLength"]);

  const {
    register,
    error,
    hasErrors
  } = useVFormContext(name, label);
  const {
    id,
    helpId,
    errorId
  } = getFieldIds(name);
  const describedBy = classnames({
    [helpId]: !!helpText,
    [errorId]: hasErrors
  });

  const _b = register(name, {
    required
  }),
        {
    ref: innerRef
  } = _b,
        registerOut = __rest(_b, ["ref"]);

  const handleChange = elem => {
    setValue(elem.target.value);

    if (props.handleChange) {
      props.handleChange(elem);
    }
  };

  return jsxs(VFieldWrapper, Object.assign({}, Object.assign(Object.assign({}, props), {
    hasErrors,
    error
  }), {
    children: [jsx(RawVInputField, Object.assign({}, Object.assign(Object.assign(Object.assign(Object.assign({}, inputProps), {
      key: id,
      handleChange,
      type: 'textarea',
      as: 'textarea',
      id,
      maxLength,
      hasErrors,
      innerRef
    }), registerOut), {
      'aria-describedby': describedBy || undefined,
      'aria-required': required
    })), void 0), maxLength && jsxs("p", Object.assign({
      className: "instructional-text"
    }, {
      children: [maxLength - ((_a = value === null || value === void 0 ? void 0 : value.length) !== null && _a !== void 0 ? _a : 0), " characters remaining."]
    }), void 0)]
  }), void 0);
}

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis = functionUncurryThis;
var requireObjectCoercible$1 = requireObjectCoercible$7;
var toString$1 = toString$7;
var whitespaces$1 = whitespaces$2;

var replace = uncurryThis(''.replace);
var whitespace = '[' + whitespaces$1 + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString$1(requireObjectCoercible$1($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var fails = fails$i;
var whitespaces = whitespaces$2;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $ = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

function VAddress(props) {
  const {
    address,
    variant
  } = props;

  if (variant === 'single-line') {
    return jsx(Fragment, {
      children: [address.addressLine1, address.addressLine2, address.city, address.state, address.zipcode, address.country].filter(item => !!(item === null || item === void 0 ? void 0 : item.trim())).join(', ')
    }, void 0);
  }

  return jsxs(Fragment, {
    children: [jsx("div", {
      children: address.addressLine1
    }, void 0), address.addressLine2 ? jsx("div", {
      children: address.addressLine2
    }, void 0) : null, jsxs("div", {
      children: [address.city, ", ", address.state, ", ", address.zipcode]
    }, void 0), address.country ? jsx("div", {
      children: address.country
    }, void 0) : null]
  }, void 0);
}

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es-x/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

var call = functionCall;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject = anObject$9;
var requireObjectCoercible = requireObjectCoercible$7;
var sameValue = sameValue$1;
var toString = toString$7;
var getMethod = getMethod$3;
var regExpExec = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = regexp == undefined ? undefined : getMethod(regexp, SEARCH);
      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

function VAuthenticatedRoute(props) {
  const {
    children,
    restrictAccess
  } = props;
  const {
    isLoading,
    user
  } = useAuthentication();
  const location = useLocation();

  if (isLoading) {
    return jsx(VLoader, {}, void 0);
  }

  const hasAccess = restrictAccess ? restrictAccess(user) : true;

  if (user && hasAccess) {
    return children;
  }

  if (!hasAccess) {
    throw Error('404');
  }

  const {
    pathname,
    search
  } = location;
  return jsx(Navigate, {
    "data-testid": "test",
    to: "/sign-in",
    state: {
      from: {
        pathname: encodeURIComponent(`${pathname}${search.replace(/&/g, '+')}`)
      }
    }
  }, void 0);
}

function VButtonRow(props) {
  const {
    className = '',
    children
  } = props;
  return jsx(Row, Object.assign({
    className: `vstart-button-row ${className}`
  }, {
    children: jsx(Col, Object.assign({
      className: "d-flex flex-column flex-sm-row"
    }, {
      children: children
    }), void 0)
  }), void 0);
}

const FIVE_SECONDS = 5000;
function VCarousel(props) {
  const {
    children,
    interval,
    controls = true,
    indicators = true
  } = props;
  return jsx(Carousel, Object.assign({
    touch: true,
    controls: controls,
    indicators: indicators,
    interval: interval || FIVE_SECONDS
  }, {
    children: children.map((item, index) => {
      return jsx(Carousel.Item, {
        children: item
      }, `carousel-${index}`);
    })
  }), void 0);
}

function VCenterColumnOnly(props) {
  const {
    children
  } = props;
  return jsx(Row, {
    children: jsx(Col, Object.assign({
      md: {
        span: 8
      },
      lg: {
        span: 4
      },
      className: "mx-auto"
    }, {
      children: children
    }), void 0)
  }, void 0);
}

const CollapsibleContext = /*#__PURE__*/React.createContext(() => {});

library.add(faCompressAlt, faExpandAlt);
function VToggleButtons({
  setToggleAll,
  collapseDisabled,
  expandDisabled
}) {
  const closeAll = () => setToggleAll(false);

  const showAll = () => setToggleAll(true);

  return jsxs(Fragment, {
    children: [jsxs("button", Object.assign({
      "data-testid": "collapse-btn",
      type: "button",
      className: classnames('btn', {
        isDisabled: collapseDisabled
      }),
      onClick: closeAll
    }, {
      children: [jsx(FontAwesomeIcon, {
        className: "icon",
        size: "1x",
        icon: "compress-alt"
      }, void 0), "Collapse All"]
    }), void 0), jsxs("button", Object.assign({
      "data-testid": "expand-btn",
      type: "button",
      className: classnames('btn', {
        isDisabled: expandDisabled
      }),
      onClick: showAll
    }, {
      children: [jsx(FontAwesomeIcon, {
        className: "icon",
        size: "1x",
        icon: "expand-alt"
      }, void 0), "Expand All"]
    }), void 0)]
  }, void 0);
}

function groupReducer(state, action) {
  const {
    type,
    value
  } = action;

  switch (type) {
    case 'registerChild':
      {
        const {
          sectionId
        } = value;
        return Object.assign(Object.assign({}, state), {
          [sectionId]: value
        });
      }

    case 'unregisterChild':
      {
        const sectionId = value;

        if (sectionId in state) {
          return {};
        }

        return state;
      }

    case 'expand-collapse':
      {
        const nextState = {};
        const sections = state;
        Object.values(sections).forEach(section => nextState[section.sectionId] = Object.assign(Object.assign({}, section), {
          isOpen: value
        }));
        return nextState;
      }

    default:
      return state;
  }
}

function VCollapsibleGroup({
  children
}) {
  const [state, dispatch] = useReducer(groupReducer, {});
  const sectionState = state;
  const sectionValues = Object.values(sectionState);
  const atleastOneOpen = sectionValues.some(p => p.isOpen);
  const atleastOneClosed = sectionValues.some(p => !p.isOpen);
  const collapseEnabled = atleastOneOpen;
  const expandEnabled = atleastOneClosed;

  function toggleAll(value) {
    Object.values(sectionValues).forEach(section => section.setIsOpen(value));
    dispatch({
      type: 'expand-collapse',
      value
    });
  }

  return jsx(CollapsibleContext.Provider, Object.assign({
    value: dispatch
  }, {
    children: jsxs("div", Object.assign({
      className: "expand-collapse"
    }, {
      children: [jsx(VToggleButtons, {
        setToggleAll: toggleAll,
        collapseDisabled: !collapseEnabled,
        expandDisabled: !expandEnabled
      }, void 0), children, jsx(VToggleButtons, {
        setToggleAll: toggleAll,
        collapseDisabled: !collapseEnabled,
        expandDisabled: !expandEnabled
      }, void 0)]
    }), void 0)
  }), void 0);
}

library.add(faAngleUp, faAngleDown);

const VCollapsibleSection = props => {
  const {
    children,
    sectionId,
    title,
    icon,
    defaultIsOpen = false,
    handleClick,
    classes = '',
    rightIconClosed = 'angle-down',
    rightIconOpen = 'angle-up'
  } = props;
  const dispatch = useContext(CollapsibleContext);
  const [isOpen, setIsOpen] = useState(defaultIsOpen);
  const className = isOpen ? 'collapse show' : 'collapse';
  const rightIcon = isOpen ? rightIconOpen : rightIconClosed;

  const click = () => {
    handleClick && handleClick();
    const toggle = !isOpen;
    setIsOpen(toggle);
    dispatch({
      type: 'registerChild',
      value: {
        sectionId,
        isOpen: toggle,
        setIsOpen
      }
    });
  };

  useEffect(() => {
    if (defaultIsOpen) {
      setIsOpen(defaultIsOpen);
    }

    dispatch({
      type: 'registerChild',
      value: {
        sectionId,
        isOpen,
        setIsOpen
      }
    });
    return () => dispatch({
      type: 'unregisterChild',
      value: sectionId
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultIsOpen]);
  return jsxs("section", Object.assign({
    className: classnames('collapsible-section', classes, {
      open: isOpen
    })
  }, {
    children: [jsxs("div", Object.assign({
      className: "click-area",
      onClick: click,
      role: "button"
    }, {
      children: [icon, jsx("div", Object.assign({
        "data-testid": "collapse-click",
        className: "collapsible-section-header",
        id: `heading${sectionId}`,
        "data-toggle": "collapse",
        "data-target": `#${sectionId}`,
        "aria-expanded": isOpen,
        "aria-controls": sectionId
      }, {
        children: title
      }), void 0), jsx("button", Object.assign({
        style: {
          border: 0,
          background: 'transparent',
          paddingLeft: '1rem',
          paddingRight: '1rem'
        }
      }, {
        children: jsx(FontAwesomeIcon, {
          className: "caret",
          size: "2x",
          icon: rightIcon
        }, void 0)
      }), void 0)]
    }), void 0), jsx("div", Object.assign({
      id: sectionId,
      className: className,
      "aria-labelledby": `heading${sectionId}`
    }, {
      children: jsx("div", Object.assign({
        className: "card-body"
      }, {
        children: children
      }), void 0)
    }), void 0)]
  }), void 0);
};

// import { useLocation } from 'react-router-dom';
// import { authUserSelector } from 'lib/redux/auth-selector';
// import { formSelector } from 'lib/redux/form-selector';
// import { formUpdate } from 'lib/redux/form-slice';
// import { CONFIRM_WITHOUT_SAVING } from 'lib/utils/constants/text-constants';

const VDirtyPrompt = () => {
  // const { pathname: previousPathname } = useLocation();
  // const { listen } = useHistory();
  // const { isDirty } = useSelector(formSelector);
  // const user = useSelector(authUserSelector);
  // const dispatch = useDispatch();
  // // If the user is routing to a new page and the form state is dirty, reset it.
  // listen(({ pathname: currentPathname }: any) => {
  //   if (previousPathname !== currentPathname && isDirty) {
  //     dispatch(formUpdate({ isDirty: false }));
  //   }
  // });
  // return <Prompt when={!!user && isDirty} message={CONFIRM_WITHOUT_SAVING} />;
  return jsx("div", {
    children: "This needs work"
  }, void 0);
};

function VDoubleColView(props) {
  const {
    className = '',
    children
  } = props;
  return jsx(Row, Object.assign({}, {
    className
  }, {
    children: children === null || children === void 0 ? void 0 : children.map((child, index) => jsx(Col, Object.assign({
      className: `inner-col inner-col-${index}`,
      md: "6"
    }, {
      children: child
    }), index))
  }), void 0);
}

library.add(faCheckCircle);
function VDropdownNav(props) {
  const {
    steps,
    rootPath,
    display = 'inline-block'
  } = props;
  const location = useLocation();
  const currentStep = steps.find(step => `${rootPath}${step.path}` === location.pathname) || {
    name: 'Select a step...'
  };
  return jsxs(Dropdown, Object.assign({
    className: `vstart-dropdown-nav d-${display}`
  }, {
    children: [jsx(Dropdown.Toggle, Object.assign({
      id: "dropdown-basic",
      className: "w-100"
    }, {
      children: currentStep.name
    }), void 0), jsx(Dropdown.Menu, Object.assign({
      className: "w-100"
    }, {
      children: steps.map((step, index) => {
        const stepPath = `${rootPath}${step.path}`;
        const {
          name,
          isComplete
        } = step;
        const isActive = `${rootPath}${step.path}` === location.pathname;
        return jsx(Dropdown.Item, Object.assign({
          as: Link,
          to: stepPath,
          active: isActive,
          disabled: step.isDisabled
        }, {
          children: jsxs("div", Object.assign({
            className: "vstart-dropdown-nav-link-wrapper"
          }, {
            children: [name, isComplete && jsx(FontAwesomeIcon, {
              icon: "check-circle",
              "data-testid": `complete-icon-${index}`
            }, void 0)]
          }), void 0)
        }), stepPath);
      })
    }), void 0)]
  }), void 0);
}

function VMainLayout(props) {
  const {
    children,
    className,
    id,
    rightHandComponent
  } = props;
  return jsxs(Row, Object.assign({}, {
    className,
    id
  }, {
    children: [jsx(Col, {
      children: children
    }, void 0), rightHandComponent && jsx(Col, {
      children: rightHandComponent()
    }, void 0)]
  }), void 0);
}

function VError({
  homePath,
  error,
  title,
  message
}) {
  useVSkipNav('main-content-error');
  return jsx(Container, {
    children: jsx(VMainLayout, {
      children: jsxs("div", Object.assign({
        id: "main-content-error",
        className: "text-center mt-5"
      }, {
        children: [jsxs("div", Object.assign({
          id: "error-text"
        }, {
          children: [jsx("h1", Object.assign({
            id: "main-content-error",
            "data-testid": error,
            className: "vstart-error-page-heading"
          }, {
            children: error
          }), void 0), jsx("h2", Object.assign({
            className: "display-4"
          }, {
            children: title
          }), void 0), jsx("p", Object.assign({
            className: "mt-3"
          }, {
            children: message
          }), void 0)]
        }), void 0), jsx(VButton, Object.assign({
          to: homePath,
          className: "mt-3"
        }, {
          children: "Return Home"
        }), void 0)]
      }), void 0)
    }, void 0)
  }, void 0);
}

const history = createHistory();
class VErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      is404: false
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      is404: error.message === '404'
    };
  }

  render() {
    const {
      hasError,
      is404
    } = this.state;
    const {
      children
    } = this.props;
    history.listen(() => {
      if (hasError) {
        this.setState({
          hasError: false
        });
      }
    });

    if (hasError && is404) {
      return jsx(VError, {
        homePath: "/",
        error: "404",
        title: "Page Not Found",
        message: "Sorry, we couldn't find the page you're looking for."
      }, void 0);
    }

    if (hasError) {
      return jsx(VError, {
        homePath: "/",
        error: "500",
        title: "Something went wrong",
        message: "Please try again."
      }, void 0);
    }

    return children;
  }

}

function VFooterLinkColumn(props) {
  const {
    columnData,
    testId
  } = props;
  const {
    title,
    linkList
  } = columnData;
  return jsxs(Col, Object.assign({
    className: "mt-3",
    "data-testid": testId
  }, {
    children: [jsx("h3", {
      children: title
    }, void 0), jsx("ul", {
      children: linkList.map(link => {
        return jsx("li", {
          children: jsx("a", Object.assign({
            href: link.url,
            target: link.external ? '_blank' : '',
            rel: "noopener noreferrer"
          }, {
            children: link.label
          }), void 0)
        }, link.label);
      })
    }, void 0)]
  }), void 0);
}

function VFooter(props) {
  const {
    logo,
    phone,
    email,
    columns,
    copyright,
    children
  } = props || {};
  const footerColumns = columns === null || columns === void 0 ? void 0 : columns.map((column, i) => jsx(VFooterLinkColumn, {
    columnData: column,
    testId: `test-col-${i}`
  }, i));
  return jsx("footer", {
    children: jsx(Container, {
      children: jsxs("div", {
        children: [jsx("h2", Object.assign({
          className: "visually-hidden"
        }, {
          children: "Footer Links"
        }), void 0), children ? children : jsxs(Fragment, {
          children: [jsxs(Row, Object.assign({
            className: "firstRow"
          }, {
            children: [logo && jsx(Col, Object.assign({
              sm: "4",
              lg: "3",
              "data-testid": "test-logo"
            }, {
              children: logo
            }), void 0), jsx(Col, Object.assign({
              className: "footerNav"
            }, {
              children: columns && footerColumns
            }), void 0)]
          }), void 0), jsxs(Row, {
            children: [jsx(Col, {
              children: copyright && jsxs("span", Object.assign({
                "data-testid": "test-copyright"
              }, {
                children: ["\u00A9 ", copyright]
              }), void 0)
            }, void 0), jsxs(Col, Object.assign({
              className: "text-end"
            }, {
              children: [phone && jsx("span", Object.assign({
                className: "pe-3 metadata",
                "data-testid": "test-phone"
              }, {
                children: phone
              }), void 0), email && jsx("span", Object.assign({
                className: "pe-3 metadata",
                "data-testid": "test-email"
              }, {
                children: email
              }), void 0)]
            }), void 0)]
          }, void 0)]
        }, void 0)]
      }, void 0)
    }, void 0)
  }, void 0);
}

const VHeaderButtonToggle = /*#__PURE__*/forwardRef(({
  children,
  onClick,
  closeIcon,
  openIcon,
  isShown
}, ref) => {
  const icon = isShown ? openIcon || 'caret-up' : closeIcon || 'caret-down';

  const toggleOpen = e => {
    e.preventDefault();
    onClick(e);
  };

  return jsxs("button", Object.assign({
    ref: ref,
    className: "nav-link dropdown-item vstart-custom-toggle",
    onClick: e => toggleOpen(e)
  }, {
    children: [jsx("span", Object.assign({
      className: "link-text"
    }, {
      children: children
    }), void 0), jsx(FontAwesomeIcon, {
      className: "toggle-icon ms-2",
      icon: icon
    }, void 0)]
  }), void 0);
});

function VHeaderDropdown(props) {
  const [isShown, setIsShown] = useState(false);
  const {
    item
  } = props;
  const {
    id,
    showItem,
    label,
    children,
    closeIcon,
    openIcon
  } = item;

  const toggle = () => {
    setIsShown(!isShown);
  };

  return jsxs(Dropdown, Object.assign({
    id: `${id}-options-dropdown`,
    "data-testid": `${id}-options-dropdown`,
    onToggle: toggle
  }, {
    children: [jsx(Dropdown.Toggle, Object.assign({
      as: VHeaderButtonToggle,
      closeIcon: closeIcon,
      openIcon: openIcon,
      isShown: isShown
    }, {
      children: label
    }), void 0), jsx(Dropdown.Menu, {
      children: children.map(child => {
        const {
          label: childLabel,
          action: childAction,
          showItem: childAuth = showItem // If showItem isn't defined, use parent showItem

        } = child;

        if (!childAuth) {
          return null;
        }

        if (typeof childAction === 'string') {
          return jsx(LinkContainer, Object.assign({
            to: childAction,
            "data-testid": `header-dropdown-link-${childLabel}`
          }, {
            children: jsx(Dropdown.Item, {
              children: childLabel
            }, void 0)
          }), childLabel);
        }

        return jsx(Dropdown.Item, Object.assign({
          onClick: childAction,
          "data-testid": `header-dropdown-action-${childLabel}`
        }, {
          children: childLabel
        }), childLabel);
      })
    }, void 0)]
  }), void 0);
}

function VHeaderMegaMenu(props) {
  const [isShown, setIsShown] = useState(false);
  const {
    item
  } = props;
  const {
    id,
    label,
    children,
    closeIcon,
    openIcon
  } = item;

  const toggle = () => {
    const toggleShow = !isShown;
    setIsShown(toggleShow);
  };

  return jsxs(Dropdown, Object.assign({
    id: `${id}-options-dropdown`,
    "data-testid": `${id}-options-dropdown`,
    className: "has-mega-menu",
    onToggle: toggle
  }, {
    children: [jsx(Dropdown.Toggle, Object.assign({
      as: VHeaderButtonToggle,
      closeIcon: closeIcon,
      openIcon: openIcon,
      isShown: isShown
    }, {
      children: label
    }), void 0), jsx(Dropdown.Menu, Object.assign({
      className: "mega-menu"
    }, {
      children: children
    }), void 0)]
  }), void 0);
}

function VHeaderLink(props) {
  const {
    item
  } = props;
  const {
    id,
    showItem,
    label,
    action,
    external = false
  } = item;
  const validId = (id || label).replace(/\W+/g, '_');

  if (!showItem) {
    return null;
  } // Special Case for dropdown


  if (action === 'dropdown') {
    const ddItem = item;
    return jsx(VHeaderDropdown, Object.assign({}, {
      item: Object.assign(Object.assign({}, ddItem), {
        id: validId
      })
    }), void 0);
  } // Special Case for mega menus


  if (action === 'mega-menu') {
    const menuItem = item;
    return jsx(VHeaderMegaMenu, Object.assign({}, {
      item: Object.assign(Object.assign({}, menuItem), {
        id: validId
      })
    }), void 0);
  } // String type means link somewhere


  if (typeof action === 'string') {
    if (external) {
      return jsx("a", Object.assign({
        className: "nav-link",
        href: action,
        id: validId,
        "data-testid": `header-external-link-${label}`
      }, {
        children: jsx("span", Object.assign({
          className: "link-text"
        }, {
          children: label
        }), void 0)
      }), void 0);
    }

    return jsx(LinkContainer, Object.assign({
      to: action,
      id: validId,
      "data-testid": `header-link-${label}`
    }, {
      children: jsx(Nav.Link, {
        children: jsx("span", Object.assign({
          className: "link-text"
        }, {
          children: label
        }), void 0)
      }, void 0)
    }), void 0);
  } // Anything else means its an on-click action


  return jsx(Nav.Link, Object.assign({
    onClick: action,
    id: validId,
    "data-testid": "header-action"
  }, {
    children: jsx("span", Object.assign({
      className: "link-text"
    }, {
      children: label
    }), void 0)
  }), void 0);
}

library.add(faBars);
function VHeaderNav(props) {
  const {
    logo,
    isMenuOpen,
    closeMenu,
    openMenu,
    navLinks = []
  } = props;
  const navigationClasses = classnames('vstart-nav', {
    'is-open': isMenuOpen
  });
  return jsxs(Fragment, {
    children: [jsxs("nav", Object.assign({
      "data-testid": "nav-list",
      className: navigationClasses
    }, {
      children: [jsxs("div", Object.assign({
        className: "vstart-nav-list-header m-2"
      }, {
        children: [jsx("div", Object.assign({
          className: classnames({
            'd-none': !isMenuOpen,
            'd-xl-none': isMenuOpen
          })
        }, {
          children: jsx(Link, Object.assign({
            to: "/",
            className: "vstart-header-logo"
          }, {
            children: logo || 'vStart'
          }), void 0)
        }), void 0), jsx(VButton, Object.assign({
          "data-testid": "nav-close-btn",
          onClick: closeMenu,
          "aria-label": CLOSE_NAVIGATION,
          size: "sm",
          className: "vstart-nav-close-btn"
        }, {
          children: "Close"
        }), void 0)]
      }), void 0), jsx("ul", Object.assign({
        className: "vstart-nav-list"
      }, {
        children: navLinks.map(item => {
          if (!item.showItem) {
            return null;
          }

          return jsx("li", Object.assign({
            className: classnames('dropdown nav-item', {
              'has-mega-menu': item.children && !Array.isArray(item.children)
            })
          }, {
            children: jsx(VHeaderLink, {
              item: item
            }, void 0)
          }), item.label);
        })
      }), void 0)]
    }), void 0), jsx(VButton, Object.assign({
      "data-testid": "nav-open-btn",
      size: "sm",
      variant: "outline-primary",
      onClick: openMenu,
      className: "vstart-nav-open-btn"
    }, {
      children: "Menu"
    }), void 0)]
  }, void 0);
}

function VHeader(props) {
  const {
    logo,
    navLinks = [],
    position = 'static'
  } = props;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  const headerClasses = classnames('vstart-header', {
    'position-fixed w-100': position === 'fixed'
  });
  const overlayClasses = classnames('vstart-overlay', {
    'is-open': isMenuOpen
  });

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const openMenu = () => {
    setIsMenuOpen(true);
  }; // if the route changes, close the menu


  useEffect(() => {
    closeMenu();
  }, [pathname]);
  return jsx("div", Object.assign({
    className: headerClasses
  }, {
    children: jsx(Container, {
      children: jsxs(Row, Object.assign({
        className: "vstart-header-row"
      }, {
        children: [jsxs(Col, Object.assign({
          className: "col-auto vstart-logo-wrapper"
        }, {
          children: [jsx("div", {
            className: overlayClasses,
            "data-testid": overlayClasses,
            onClick: closeMenu
          }, void 0), jsx(Link, Object.assign({
            to: "/",
            className: "vstart-header-logo"
          }, {
            children: logo || 'vStart'
          }), void 0)]
        }), void 0), jsx(Col, Object.assign({
          className: "col-auto vstart-header-nav"
        }, {
          children: jsx(VHeaderNav, {
            openMenu: openMenu,
            closeMenu: closeMenu,
            isMenuOpen: isMenuOpen,
            navLinks: navLinks,
            logo: logo
          }, void 0)
        }), void 0)]
      }), void 0)
    }, void 0)
  }), void 0);
}

function useUserMenu(options) {
  const [menuItems, setMenuItems] = useState([]);
  const {
    openIcon,
    closeIcon,
    extraLinks = [],
    signInText = SIGN_IN,
    signOutText = SIGN_OUT
  } = options;
  const authUser = useSelector(authUserSelector);
  const signOut = useAuthenticationSignOut();
  const {
    pathname
  } = useLocation();
  const {
    firstName,
    lastName
  } = authUser || {};

  const hasAccess = options => {
    const {
      require
    } = options;

    switch (require) {
      case 'authenticated':
        {
          return !!authUser;
        }

      case 'unauthenticated':
        {
          return !authUser;
        }

      default:
        {
          return true;
        }
    }
  };

  useEffect(() => {
    setMenuItems([{
      id: 'user_menu_dropdown',
      label: formatName({
        firstName,
        lastName
      }),
      showItem: hasAccess({
        require: 'authenticated'
      }),
      action: 'dropdown',
      openIcon: openIcon || 'caret-up',
      closeIcon: closeIcon || 'caret-down',
      children: [...extraLinks, {
        label: MY_PROFILE,
        action: '/my-profile',
        showItem: hasAccess({
          require: 'authenticated'
        })
      }, {
        label: signOutText,
        action: signOut,
        showItem: hasAccess({
          require: 'authenticated'
        })
      }]
    }, {
      label: signInText,
      showItem: hasAccess({
        require: 'unauthenticated'
      }),
      action: cognitoUrl(pathname),
      external: true
    }]); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);
  return {
    // Provides a method to check if a user has acccess
    hasAccess,
    // Provides a standard set of menu links for an showItem user and a login button for unauthenticated users
    menuItems
  };
}

library.add(faCheckCircle);
function VLeftNav(props) {
  const {
    steps,
    rootPath
  } = props;
  const location = useLocation();
  return jsx("div", Object.assign({
    className: "vstart-left-nav"
  }, {
    children: jsx(Nav, Object.assign({
      className: "d-none d-sm-flex flex-column",
      "data-testid": "left-hand-navigation"
    }, {
      children: steps.map(({
        path,
        name,
        isComplete,
        isDisabled
      }, index) => {
        const combinedPath = `${rootPath}${path}`;
        const isActive = location.pathname === combinedPath;
        return jsx(Nav.Item, {
          children: jsxs(Nav.Link, Object.assign({
            "data-testid": `nav-${index}`,
            active: isActive,
            to: combinedPath,
            as: Link,
            disabled: isDisabled,
            "aria-label": name,
            "aria-disabled": isDisabled
          }, {
            children: [name, isComplete && jsx(FontAwesomeIcon, {
              icon: "check-circle",
              className: "ms-3 vstart-left-nav-success-icon",
              "data-testid": `complete-icon-${index}`
            }, void 0)]
          }), void 0)
        }, `${combinedPath}-${index}`);
      })
    }), void 0)
  }), void 0);
}

function VSwitch(props) {
  const {
    children
  } = props;
  return jsxs(Routes, {
    children: [children, jsx(Route, {
      path: "*",
      element: jsx(VError, {
        homePath: "/",
        error: "404",
        title: "Page Not Found",
        message: "Sorry, we couldn't find the page you're looking for."
      }, void 0)
    }, void 0)]
  }, void 0);
}

function VLeftHandNavigation(props) {
  const {
    navigation,
    leftSpan = {
      md: 3
    },
    mainSpan = {
      md: 6
    }
  } = props;
  return jsxs(Row, {
    children: [jsx(Col, Object.assign({}, leftSpan, {
      children: jsx(VLeftNav, Object.assign({}, {
        rootPath: '',
        steps: navigation
      }), void 0)
    }), void 0), jsx(Col, Object.assign({}, mainSpan, {
      "data-testid": "left-hand-body"
    }, {
      children: jsx(VSwitch, {
        children: navigation.map(step => {
          return jsx(Route, {
            path: step.path,
            element: step.component
          }, step.path);
        })
      }, void 0)
    }), void 0)]
  }, void 0);
}

const VNoInfo = ({
  value,
  noInfoTextOverride,
  ariaLabel,
  inline,
  dataTestId
}) => {
  const trimmedValue = typeof value === 'string' ? value.trim() : value;

  if (trimmedValue) {
    return inline ? jsx("span", Object.assign({
      "aria-labelledby": ariaLabel
    }, {
      children: trimmedValue
    }), void 0) : jsx("p", Object.assign({
      "aria-labelledby": ariaLabel
    }, {
      children: trimmedValue
    }), void 0);
  }

  return inline ? jsx("span", Object.assign({
    "data-testid": dataTestId,
    className: "vstart-not-available"
  }, {
    children: noInfoTextOverride || 'Not available'
  }), void 0) : jsx("p", Object.assign({
    "data-testid": dataTestId,
    className: "vstart-not-available"
  }, {
    children: noInfoTextOverride || 'Not available'
  }), void 0);
};

function pageSelector(state) {
  return state.page;
}

function RawVPageHeader(props) {
  const {
    documentTitle,
    header,
    homePath,
    homeLinkText = 'Home'
  } = props;
  const {
    title,
    subtitle,
    breadCrumbs
  } = header;
  const noHeader = !title && !subtitle && !breadCrumbs;
  useEffect(() => {
    document.title = documentTitle;
  }, [documentTitle]);
  return noHeader ? null : jsx("div", Object.assign({
    className: "vstart-page-header",
    "data-testid": "page-header"
  }, {
    children: jsx(Container, {
      children: jsxs(VMainLayout, {
        children: [breadCrumbs && jsxs(Breadcrumb, {
          children: [jsx(LinkContainer, Object.assign({
            to: homePath
          }, {
            children: jsx(Breadcrumb.Item, {
              children: homeLinkText
            }, void 0)
          }), void 0), breadCrumbs.map(({
            title: crumbTitle,
            link
          }) => {
            if (!link) {
              return jsx(Breadcrumb.Item, Object.assign({}, {
                key: crumbTitle,
                active: true
              }, {
                children: crumbTitle
              }), void 0);
            }

            return jsx(LinkContainer, Object.assign({}, {
              key: crumbTitle,
              to: link
            }, {
              children: jsx(Breadcrumb.Item, {
                children: crumbTitle
              }, void 0)
            }), void 0);
          })]
        }, void 0), title && jsx("h1", Object.assign({
          "data-testid": "page-header-title"
        }, {
          children: title
        }), void 0), title && jsx("h3", Object.assign({
          "data-testid": "page-header-subtitle"
        }, {
          children: subtitle
        }), void 0)]
      }, void 0)
    }, void 0)
  }), void 0);
}

function VPageHeader({
  homeLinkText = 'Home'
}) {
  const {
    documentTitle,
    header
  } = useSelector(pageSelector);
  return jsx(RawVPageHeader, {
    documentTitle: documentTitle,
    header: header,
    homePath: "/",
    homeLinkText: homeLinkText
  }, void 0);
}

function determineSpan(props) {
  const {
    size
  } = props;

  switch (size) {
    case 'full':
      {
        return {
          md: 12
        };
      }

    case 'three-quarter':
      {
        return {
          md: 9
        };
      }

    case 'quarter':
      {
        return {
          md: 3
        };
      }

    default:
      {
        return {
          md: 6
        };
      }
  }
}
function VSingleColView(props) {
  const {
    className = '',
    children
  } = props;
  const colSpan = determineSpan(props);
  return jsx(Row, Object.assign({}, {
    className
  }, {
    children: jsx(Col, Object.assign({}, colSpan, {
      children: children
    }), void 0)
  }), void 0);
}

function VSkipNav(props) {
  const {
    children,
    skipText = 'Skip to Main Content'
  } = props;
  const [target, setTarget] = useState();
  return jsxs(Fragment, {
    children: [jsx(VOptional, Object.assign({
      show: !!target
    }, {
      children: jsx(VButton, Object.assign({
        variant: "primary",
        "data-testid": "skip-nav-button",
        className: "btn-skip-nav",
        to: `#${target}`
      }, {
        children: skipText
      }), void 0)
    }), void 0), jsx(vSkipNavContext.Provider, Object.assign({
      value: setTarget
    }, {
      children: children
    }), void 0)]
  }, void 0);
}

function VStepsRouter(props) {
  const {
    steps,
    rootPath
  } = props;
  const location = useLocation();
  let step = steps.find(s => `${rootPath}${s.path}` === location.pathname);

  if (step === null || step === void 0 ? void 0 : step.isDisabled) {
    step = steps.find(s => `${rootPath}${s.path}` === rootPath);
  }

  if (!step) {
    return jsx(VError, {
      homePath: "/",
      error: "404",
      title: "Page Not Found",
      message: "Sorry, we couldn't find the page you're looking for."
    }, void 0);
  }

  return jsx(Card, {
    children: jsx(Card.Body, {
      children: step === null || step === void 0 ? void 0 : step.component
    }, void 0)
  }, void 0);
}

library.add(faCaretUp, faCaretDown);
function VSortableIcons(props) {
  const {
    colLabel,
    colSortBy,
    sortBy,
    sortDir
  } = props;

  function getSortIconColor(columnSortBy, caretIconDirection) {
    let color;

    if (columnSortBy === sortBy) {
      if (sortDir === SortDirection.ASC && caretIconDirection === 'up') {
        color = PRIMARY_COLOR;
      }

      if (sortDir === SortDirection.DESC && caretIconDirection === 'down') {
        color = PRIMARY_COLOR;
      }
    }

    return color;
  }

  return jsxs(Fragment, {
    children: [jsx("span", Object.assign({
      className: "visually-hidden",
      "data-testid": `${colLabel}-sr-click`
    }, {
      children: "(click to sort by this column)"
    }), void 0), jsxs("div", Object.assign({
      className: "ps-2 d-inline-flex flex-column justify-content-center"
    }, {
      children: [jsx(FontAwesomeIcon, {
        "data-testid": `caret-up-${colLabel}`,
        className: "vstart-sort-caret-up-icon",
        icon: "caret-up",
        color: getSortIconColor(colSortBy, 'up'),
        "aria-label": `${colLabel} Sort Ascending`
      }, void 0), jsx(FontAwesomeIcon, {
        "data-testid": `caret-down-${colLabel}`,
        icon: "caret-down",
        color: getSortIconColor(colSortBy, 'down'),
        "aria-label": `${colLabel} Sort Descending`
      }, void 0)]
    }), void 0)]
  }, void 0);
}

function VTableHeadCell(props) {
  const {
    col,
    hasSecondRow,
    sortBy,
    sortDir,
    generateClickSort,
    generateKeyPressSort
  } = props;
  const {
    label,
    srDescription,
    className,
    subLabels
  } = col;
  return jsx("th", Object.assign({
    tabIndex: col.sortBy ? 0 : undefined,
    className: className,
    scope: "col",
    "data-testid": `th-${label}`,
    onClick: generateClickSort(col),
    onKeyPress: generateKeyPressSort(col),
    rowSpan: hasSecondRow && subLabels ? 1 : 2,
    colSpan: subLabels ? subLabels.length : 1
  }, {
    children: jsxs("div", Object.assign({
      className: "d-flex"
    }, {
      children: [label && jsx("span", Object.assign({
        "data-testid": `${label}-label`
      }, {
        children: label
      }), void 0), srDescription && jsx("span", Object.assign({
        className: "visually-hidden",
        "data-testid": `${label}-srDescription`
      }, {
        children: srDescription
      }), void 0), col.sortBy && jsx(VSortableIcons, Object.assign({}, {
        sortBy,
        sortDir,
        colLabel: label,
        colSortBy: col.sortBy
      }), void 0)]
    }), void 0)
  }), label);
}

function VTableHeader(props) {
  const {
    columns,
    sortDir,
    setSortDir,
    sortBy,
    setSortBy
  } = props;

  function updateSort(columnSortBy) {
    if (columnSortBy === sortBy) {
      setSortDir(sortDir === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC);
    } else {
      setSortBy(columnSortBy);
      setSortDir(SortDirection.ASC);
    }
  }

  function generateClickSort(col) {
    if (!col.sortBy) {
      return undefined;
    }

    return () => {
      updateSort(col.sortBy);
    };
  }

  function generateKeyPressSort(col) {
    if (!col.sortBy) {
      return undefined;
    }

    return e => {
      if (e.key === 'Enter') {
        updateSort(col.sortBy);
      }
    };
  }

  const hasSecondRow = columns.some(col => col.subLabels);
  return jsxs("thead", {
    children: [jsx("tr", {
      children: columns.map(col => jsx(VTableHeadCell, Object.assign({}, {
        key: col.label || col.srDescription,
        col,
        hasSecondRow,
        generateClickSort,
        generateKeyPressSort,
        sortDir,
        sortBy
      }), void 0))
    }, void 0), hasSecondRow ? jsx("tr", {
      children: columns.map(col => {
        if (!col.subLabels) {
          return null;
        }

        return col.subLabels.map(subLabel => jsx(VTableHeadCell, Object.assign({}, {
          key: subLabel.label || subLabel.srDescription,
          col: Object.assign({
            className: col.className
          }, subLabel),
          hasSecondRow,
          generateClickSort,
          generateKeyPressSort,
          sortDir,
          sortBy
        }), void 0));
      })
    }, void 0) : null]
  }, void 0);
}

function VTableRowActionsButton(props) {
  const {
    item
  } = props;
  const {
    action,
    variant,
    disabled,
    name,
    ariaLabel,
    icon: Icon
  } = item;

  if (typeof action === 'string') {
    return jsx(LinkContainer, Object.assign({
      to: action
    }, {
      children: jsxs(Button, Object.assign({
        className: "py-0 pe-2 ps-0",
        variant: variant,
        disabled: disabled,
        "aria-label": ariaLabel,
        "data-testid": "row-action-button-link"
      }, {
        children: [Icon && jsx(Icon, {}, void 0), " ", name]
      }), void 0)
    }), void 0);
  }

  return jsxs(Button, Object.assign({
    className: "py-0 px-2",
    variant: variant,
    onClick: action,
    disabled: disabled,
    "aria-label": ariaLabel,
    "data-testid": "row-action-button-function"
  }, {
    children: [Icon && jsx(Icon, {}, void 0), " ", name]
  }), void 0);
}

function VTableRowActionsDropdownItem(props) {
  const {
    item
  } = props;
  const {
    action,
    icon: Icon,
    name,
    ariaLabel
  } = item;

  if (typeof action === 'string') {
    return jsx(LinkContainer, Object.assign({
      to: action,
      "data-testid": "row-action-dropdown-link"
    }, {
      children: jsxs(Dropdown.Item, Object.assign({
        "aria-label": ariaLabel
      }, {
        children: [Icon && jsx(Icon, {
          className: "me-3"
        }, void 0), " ", name]
      }), void 0)
    }), void 0);
  }

  return jsxs(Dropdown.Item, Object.assign({
    onClick: action,
    "aria-label": ariaLabel,
    "data-testid": "row-action-dropdown-function"
  }, {
    children: [Icon && jsx(Icon, {
      className: "me-3"
    }, void 0), " ", name]
  }), void 0);
}

library.add(faEllipsisH);
function VTableRowActions(props) {
  const {
    actions,
    ariaActionsLabel
  } = props;
  const hasOneAction = actions.length === 1;
  const hasThreeActions = actions.length >= 3;
  return jsxs(Fragment, {
    children: [jsxs("div", Object.assign({
      className: "d-none d-sm-block"
    }, {
      children: [!hasThreeActions && jsx("div", Object.assign({
        "data-testid": "row-actions-less-than-three"
      }, {
        children: actions.map((action, index) => jsx(VTableRowActionsButton, {
          item: action
        }, index))
      }), void 0), hasThreeActions && jsx("div", Object.assign({
        "data-testid": "row-actions-three-or-more"
      }, {
        children: jsxs(Dropdown, {
          children: [jsx(Dropdown.Toggle, Object.assign({
            className: "btn btn-link p-0",
            variant: "link"
          }, {
            children: "Actions"
          }), void 0), jsx(Dropdown.Menu, {
            children: actions.map((action, index) => jsx(VTableRowActionsDropdownItem, {
              item: action
            }, index))
          }, void 0)]
        }, void 0)
      }), void 0)]
    }), void 0), jsxs("div", Object.assign({
      className: "d-sm-none d-block"
    }, {
      children: [hasOneAction && jsx("div", Object.assign({
        "data-testid": "row-actions-exactly-one"
      }, {
        children: jsx(VTableRowActionsButton, {
          item: actions[0]
        }, void 0)
      }), void 0), !hasOneAction && jsxs(Dropdown, {
        children: [jsxs(Dropdown.Toggle, Object.assign({
          variant: "outline-primary",
          className: "btn-condensed"
        }, {
          children: [jsx(FontAwesomeIcon, {
            icon: "ellipsis-h"
          }, void 0), ' ', jsx("span", Object.assign({
            className: "visually-hidden"
          }, {
            children: ariaActionsLabel
          }), void 0)]
        }), void 0), jsx(Dropdown.Menu, {
          children: actions.map((action, index) => jsx(VTableRowActionsDropdownItem, {
            item: action
          }, index))
        }, void 0)]
      }, void 0)]
    }), void 0)]
  }, void 0);
}

const getPaginationPages = ({
  pages,
  currentPage,
  limit
}) => {
  const halfLimit = Math.floor(limit / 2);
  const startPage = currentPage > halfLimit ? currentPage - halfLimit : 1;
  const endPage = startPage + limit > pages ? pages + 1 : startPage + limit;
  const pageArray = [];

  for (let i = startPage; i < endPage; i += 1) {
    pageArray.push(i);
  }

  return pageArray;
};

library.add(faAngleDoubleLeft, faAngleLeft, faAngleRight, faAngleDoubleRight);
function VPagination(props) {
  const {
    pages,
    page,
    setPage
  } = props;

  if (pages < 2) {
    return null;
  }

  const pageArray = getPaginationPages({
    pages,
    currentPage: page,
    limit: 5
  });
  return jsxs(Pagination, Object.assign({
    "data-testid": "table-pagination"
  }, {
    children: [jsxs(Pagination.Item, Object.assign({
      disabled: 1 === page,
      "data-testid": "table-pagination-start",
      onClick: () => setPage(1)
    }, {
      children: [jsx(FontAwesomeIcon, {
        icon: "angle-double-left",
        "aria-label": "First Page",
        className: "vstart-pagination-icon"
      }, void 0), jsx("span", Object.assign({
        className: "visually-hidden"
      }, {
        children: "First Page"
      }), void 0)]
    }), void 0), jsxs(Pagination.Item, Object.assign({
      disabled: 1 === page,
      "data-testid": "table-pagination-prev",
      onClick: () => setPage(page - 1)
    }, {
      children: [jsx(FontAwesomeIcon, {
        icon: "angle-left",
        "aria-label": "Previous Page",
        className: "vstart-pagination-icon"
      }, void 0), jsx("span", Object.assign({
        className: "visually-hidden"
      }, {
        children: "Previous Page"
      }), void 0)]
    }), void 0), Array.from({
      length: pages
    }, (_, index) => {
      const normalIndex = index + 1;

      const step = jsxs(Pagination.Item, Object.assign({
        active: index + 1 === page,
        "data-testid": "table-pagination-number",
        onClick: () => setPage(normalIndex)
      }, {
        children: [jsxs("span", Object.assign({
          className: "visually-hidden"
        }, {
          children: ["Page ", normalIndex]
        }), void 0), ' ', normalIndex]
      }), index);

      const ellipsisStep = jsxs(Pagination.Item, Object.assign({
        disabled: true,
        "data-testid": "table-pagination-ellipsis"
      }, {
        children: [jsx("span", Object.assign({
          className: "visually-hidden"
        }, {
          children: "Indication of more pages"
        }), void 0), "..."]
      }), index); // show ellipsis before the shown pages


      if (pageArray[0] - 1 === normalIndex) return ellipsisStep;
      if (pageArray.some(pageNumber => pageNumber === normalIndex)) return step; // show ellipsis after the shown pages

      if (pageArray[pageArray.length - 1] + 1 === normalIndex) return ellipsisStep;
      return undefined;
    }), jsxs(Pagination.Item, Object.assign({
      disabled: pages === page,
      "data-testid": "table-pagination-next",
      onClick: () => setPage(page + 1)
    }, {
      children: [jsx(FontAwesomeIcon, {
        icon: "angle-right",
        "aria-label": "Next Page",
        className: "vstart-pagination-icon"
      }, void 0), jsx("span", Object.assign({
        className: "visually-hidden"
      }, {
        children: "Next Page"
      }), void 0)]
    }), void 0), jsxs(Pagination.Item, Object.assign({
      disabled: pages === page,
      "data-testid": "table-pagination-end",
      onClick: () => setPage(pages)
    }, {
      children: [jsx(FontAwesomeIcon, {
        icon: "angle-double-right",
        "aria-label": "Last Page",
        className: "vstart-pagination-icon"
      }, void 0), jsx("span", Object.assign({
        className: "visually-hidden"
      }, {
        children: "Last Page"
      }), void 0)]
    }), void 0)]
  }), void 0);
}

function VTableWithPagination(props) {
  const {
    count,
    page,
    setPage,
    pages,
    title,
    results,
    limit,
    children,
    countType,
    paginationAlignment = 'start',
    responsive
  } = props;

  function resultsCount() {
    const countTypeString = count > 1 ? countType.pluralName : countType.name;

    if (page === 1 && results) {
      return `1 -  ${results.length} of ${count} ${countTypeString}`;
    }

    if (page > 1 && results) {
      const start = (page - 1) * limit + 1;
      const end = (page - 1) * limit + results.length;
      return `${start} - ${end} of ${count} ${countTypeString}`;
    }

    return 'No results';
  }

  return jsxs("div", Object.assign({
    className: "d-flex flex-column"
  }, {
    children: [jsx("div", Object.assign({
      className: "mb-3"
    }, {
      children: resultsCount()
    }), void 0), jsx("div", {
      children: jsxs(Table, Object.assign({
        striped: true,
        responsive: responsive
      }, {
        children: [jsx("caption", Object.assign({
          className: "visually-hidden"
        }, {
          children: title
        }), void 0), children]
      }), void 0)
    }, void 0), jsx("div", Object.assign({
      className: `d-flex justify-content-${paginationAlignment}`
    }, {
      children: jsx(VPagination, Object.assign({}, {
        page,
        setPage,
        pages
      }), void 0)
    }), void 0)]
  }), void 0);
}

function RawVWizardNav(props) {
  const {
    children
  } = props;
  return jsx(Nav, Object.assign({
    className: "vstart-wizard-nav d-none d-md-flex"
  }, {
    children: children
  }), void 0);
}

function RawVWizardNavDropdown(props) {
  const {
    label,
    children
  } = props;
  return jsxs(Dropdown, Object.assign({
    className: "vstart-wizard-dropdown d-md-none"
  }, {
    children: [jsx(Dropdown.Toggle, Object.assign({
      id: "dropdown-basic",
      className: "my-1 w-100"
    }, {
      children: label
    }), void 0), jsx(Dropdown.Menu, Object.assign({
      className: "w-100"
    }, {
      children: children
    }), void 0)]
  }), void 0);
}

library.add(faCheckCircle);
function VWizardNavDropdownItem(props) {
  const {
    name,
    stepPath,
    index,
    status
  } = props;
  const isActive = useMatch({
    path: stepPath
  });
  const {
    setCurrentStepIndex
  } = useContext(VWizardContext);
  useEffect(() => {
    isActive && setCurrentStepIndex(index);
  }, [index, isActive, setCurrentStepIndex]);
  const dropdownClasses = classnames('vstart-wizard-dropdown', {
    active: !!isActive,
    'is-complete': status === 'complete'
  });
  return jsx(LinkContainer, Object.assign({
    to: stepPath
  }, {
    children: jsx(Dropdown.Item, Object.assign({
      disabled: status === 'disabled',
      "data-testid": `vstart-wizard-dropdown-item-${index + 1}`,
      className: dropdownClasses
    }, {
      children: jsxs(Row, {
        children: [jsx(Col, Object.assign({
          xs: 4,
          sm: 5,
          className: "vstart-wizard-dropdown-icon align-items-center"
        }, {
          children: status === 'complete' && jsx(FontAwesomeIcon, {
            icon: "check-circle",
            className: "vstart-complete-icon"
          }, void 0)
        }), void 0), jsx(Col, Object.assign({
          xs: 8,
          sm: 7,
          className: "vstart-wizard-dropdown-text"
        }, {
          children: name
        }), void 0)]
      }, void 0)
    }), void 0)
  }), void 0);
}

library.add(faCheckCircle);
function RawVWizardNavItem(props) {
  const {
    name,
    stepPath,
    index,
    status,
    isActive
  } = props;
  return jsxs(Nav.Item, Object.assign({
    className: "vstart-wizard-nav-item"
  }, {
    children: [jsx(Nav.Link, Object.assign({
      "data-testid": `vstart-wizard-link-${index + 1}`,
      className: classnames({
        'vstart-wizard-nav-link': status !== 'complete'
      }),
      disabled: status === 'disabled',
      active: isActive,
      to: stepPath,
      as: Link,
      "aria-label": name
    }, {
      children: status === 'complete' && jsx(FontAwesomeIcon, {
        icon: "check-circle",
        className: "vstart-complete-icon"
      }, void 0)
    }), void 0), jsx("span", Object.assign({
      "aria-hidden": "true",
      className: classnames({
        'vstart-wizard-nav-text-active': !!isActive
      })
    }, {
      children: name
    }), void 0)]
  }), void 0);
}

function VWizardNavItem(props) {
  const {
    name,
    stepPath,
    index,
    isLastStep,
    maxStepIndex,
    status
  } = props;
  const isActive = useMatch({
    path: stepPath
  });
  const {
    setCurrentStepIndex
  } = useContext(VWizardContext);
  useEffect(() => {
    if (isActive) {
      setCurrentStepIndex(index);
    }
  }, [index, isActive, setCurrentStepIndex]);
  return jsx(RawVWizardNavItem, Object.assign({}, {
    name,
    stepPath,
    index,
    isLastStep,
    status,
    isActive: !!isActive,
    maxStepIndex
  }), void 0);
}

function VWizardNavBar(props) {
  var _a;

  const {
    steps,
    rootPath,
    currentStepIndex
  } = props;
  return jsxs(Fragment, {
    children: [jsx(RawVWizardNavDropdown, Object.assign({
      label: (_a = steps[currentStepIndex]) === null || _a === void 0 ? void 0 : _a.name
    }, {
      children: steps.map((step, index) => {
        const stepPath = `${rootPath}${step.path}`;
        return jsx(VWizardNavDropdownItem, Object.assign({}, {
          name: step.name,
          stepPath,
          status: step.status,
          index,
          key: `${stepPath}-${index}`
        }), void 0);
      })
    }), void 0), jsx(RawVWizardNav, {
      children: steps.map((step, index) => {
        const stepPath = `${rootPath}${step.path}`;
        return jsx(Fragment$1, {
          children: jsx(VWizardNavItem, Object.assign({}, {
            name: step.name,
            stepPath,
            status: step.status,
            disabled: step.disabled,
            index
          }), void 0)
        }, `${stepPath}-${index}`);
      })
    }, void 0)]
  }, void 0);
}

const VWizardContext = /*#__PURE__*/createContext({
  refreshSteps: () => null,
  steps: [],
  currentStepIndex: 0,
  setCurrentStepIndex: () => null,
  goToNext: () => null,
  goToPrevious: () => null,
  data: {}
});
function VWizard(props) {
  const {
    steps,
    rootPath,
    dataSource
  } = props;
  const navigate = useNavigate();
  const [applicableSteps, setApplicableSteps] = useState(() => {
    const newSteps = steps.map(step => {
      var _a;

      return ((_a = step.updateStep) === null || _a === void 0 ? void 0 : _a.call(step, {
        currentStep: step,
        data: dataSource,
        isSetup: true
      })) || step;
    });
    return newSteps;
  });
  const [currentStepIndex, setCurrentStepIndex] = useState(0);

  function refreshSteps(data) {
    const newSteps = applicableSteps.map(step => {
      var _a;

      return ((_a = step.updateStep) === null || _a === void 0 ? void 0 : _a.call(step, {
        currentStep: step,
        data,
        isSetup: false
      })) || step;
    });
    setApplicableSteps(newSteps);
    return {
      goToNext: basePath => goToNext(newSteps, basePath),
      goToPrevious: () => goToPrevious(newSteps)
    };
  }

  function goToNext(stepsList = applicableSteps, basePath = rootPath) {
    const nextApplicableStep = stepsList.slice(currentStepIndex + 1).find(step => step.status !== 'disabled');
    nextApplicableStep && navigate(`${basePath}${nextApplicableStep.path}`);
  }

  function goToPrevious(stepsList = applicableSteps) {
    const reverseSteps = [...stepsList].reverse();
    const prevApplicableStep = reverseSteps.slice(reverseSteps.length - currentStepIndex).find(step => step.status !== 'disabled');
    prevApplicableStep && navigate(`${rootPath}${prevApplicableStep.path}`);
  }

  return jsxs(VWizardContext.Provider, Object.assign({
    value: {
      steps: applicableSteps,
      data: dataSource,
      refreshSteps,
      currentStepIndex,
      setCurrentStepIndex,
      goToNext,
      goToPrevious
    }
  }, {
    children: [jsx(VWizardNavBar, Object.assign({}, {
      rootPath,
      steps: applicableSteps,
      currentStepIndex
    }), void 0), jsx(VStepsRouter, {
      rootPath: rootPath,
      steps: steps
    }, void 0)]
  }), void 0);
}

const PreviousButton = ({
  previousButton
}) => {
  if (!previousButton) {
    return null;
  }

  if (previousButton.to) {
    return jsx(VButton, Object.assign({}, {
      variant: 'outline-primary',
      className: previousButton.className,
      'data-testid': 'previous-link',
      disabled: previousButton.disabled,
      to: previousButton.to,
      noActive: true
    }, {
      children: previousButton.text || PREVIOUS
    }), void 0);
  }

  return jsx(VButton, Object.assign({}, {
    variant: 'outline-primary',
    className: previousButton.className,
    'data-testid': 'previous-button',
    onClick: previousButton === null || previousButton === void 0 ? void 0 : previousButton.onClick,
    disabled: previousButton.disabled,
    noActive: true
  }, {
    children: previousButton.text || PREVIOUS
  }), void 0);
};

const SubmitButton = ({
  submitButton
}) => {
  if (!submitButton) {
    return null;
  }

  if (submitButton.to) {
    return jsx(VButton, Object.assign({}, {
      className: submitButton.className,
      'data-testid': 'submit',
      to: submitButton === null || submitButton === void 0 ? void 0 : submitButton.to,
      disabled: submitButton.disabled
    }, {
      children: submitButton.text || NEXT
    }), void 0);
  }

  return jsx(VButton, Object.assign({}, {
    type: 'submit',
    variant: 'primary',
    className: submitButton.className,
    'data-testid': 'submit',
    onClick: submitButton === null || submitButton === void 0 ? void 0 : submitButton.onClick,
    disabled: submitButton.disabled
  }, {
    children: submitButton.text || NEXT
  }), void 0);
};

const CancelButton = ({
  cancelButton
}) => {
  if (!cancelButton) {
    return null;
  }

  if (cancelButton.to) {
    return jsx(VButton, Object.assign({}, {
      variant: 'link',
      className: classnames(cancelButton.className, 'ms-sm-auto'),
      'data-testid': 'cancel-link',
      disabled: cancelButton.disabled,
      to: cancelButton.to
    }, {
      children: cancelButton.text || PREVIOUS
    }), void 0);
  }

  return jsx(VButton, Object.assign({}, {
    variant: 'link',
    className: classnames(cancelButton.className, 'ms-sm-auto'),
    'data-testid': 'cancel-button',
    onClick: cancelButton === null || cancelButton === void 0 ? void 0 : cancelButton.onClick,
    disabled: cancelButton.disabled
  }, {
    children: cancelButton.text || CANCEL
  }), void 0);
};

function VWizardButtonRow(props) {
  const {
    submitButton,
    cancelButton,
    previousButton
  } = props;
  return jsxs(VButtonRow, Object.assign({
    className: "vstart-wizard-button-row"
  }, {
    children: [jsx(PreviousButton, {
      previousButton: previousButton
    }, void 0), jsx(SubmitButton, {
      submitButton: submitButton
    }, void 0), jsx(CancelButton, {
      cancelButton: cancelButton
    }, void 0)]
  }), void 0);
}

export { ACCEPTABLE_FILE_HINT, ACCEPTABLE_FILE_TYPES, APPLICATION_INSTRUCTIONAL_TEXT, APPLICATION_STATUS, APPLICATION_STEPS, APPLICATION_TYPE, APPLICATION_TYPE_HELP_TEXT, APP_NAME, AUTH_SERVICE, AuthenticationContextProvider, CANCEL, CANCEL_APP, CASE_MANAGEMENT, CASE_SERVICE, CASE_TYPE_OTHER, CLOSE, CLOSE_NAVIGATION, CONFIRM, CONFIRM_DELETE, CONFIRM_REMOVE_FILE, CONFIRM_WITHOUT_SAVING, DATE_FORMAT_DISPLAY, DATE_FORMAT_INPUT, DELETE, ERROR_DATE_FORMAT, ERROR_EXACT_CHAR, ERROR_FILE_EMPTY, ERROR_FILE_TYPE, ERROR_INVALID_PATTERN, ERROR_INVALID_ZIP_CODE, ERROR_MAX_CHAR, ERROR_MAX_FILE_SIZE, ERROR_MESSAGE_REQUIRED, ERROR_MIN_CHAR, ERROR_ON_OR_AFTER_DATE, ERROR_ON_OR_BEFORE_DATE, ERROR_ON_OR_BEFORE_TODAY, ERROR_SELECT_OPTION, ERROR_SERVER_GENERIC, EVIDENCE_STEP, FILE_UPLOAD_PLACEHOLDER, FORM_TYPE, HELP, HELPTEXT_MESSAGE, HOME, LANDING_WELCOME, MENU, MY_PROFILE, NEXT, NICKNAME_DEFAULT_VALUE, NOT_AVAILABLE, NO_NAME_PROVIDED, PERSONAL_INFO_STEP, PREVIOUS, PREVIOUS_BUTTON, PRIMARY_COLOR, PROCESSING_INFO_STEP, PROFILE_EDIT, PROFILE_ERROR, PROPOSED_TRAVEL_DETAILS_STEP, REENTRY_PERMIT_INFO_STEP, REFRESH_TOKEN_FAIL, REVIEW_AND_SUBMIT_STEP, SELECT_DEFAULT_OPTION_LABEL, SIGNED_OUT_ISSUE, SIGN_IN, SIGN_OUT, SIGN_UP, SUBMIT, SortDirection, TEN_MEGABYTES, UPLOAD_HELP, VAddress, VAddressFields, VAlert, VAuthenticatedRoute, VButton, VButtonRadioGroup, VButtonRow, VCarousel, VCenterColumnOnly, VCheckboxField, VCheckboxGroupField, VCheckboxInner, VCollapsibleGroup, VCollapsibleSection, VDateField, VDirtyPrompt, VDoubleColView, VDropdownNav, VErrorBoundary, VFieldError, VFieldHelpText, VFieldReturnToError, VFieldWrapper, VFieldsetWrapper, VFileUploadField, VFooter, VForm, VFormAlert, VFormContext, VFormLayout, VHeader, VIconButtonRadioGroup, VInputField, VLeftHandNavigation, VLeftNav, VLoader, VMainLayout, VModal, VModalHeader, VNoInfo, VOptional, VPageHeader, VPageTitle, VRadioGroupField, VRequiredFieldsText, VSelectField, VSingleColView, VSkipNav, VStepsRouter, VSwitch, VTableHeader, VTableRowActions, VTableWithPagination, VTextAreaField, VWizard, VWizardButtonRow, VWizardContext, ZIP_CORRECTION_MODAL, alphaHyphenApostrophePattern, alphaHyphenSpacePattern, alphaNumericSpacePattern, alphaSpacePattern, alphaSpaceSlashPattern, alphanumericPattern, alphanumericSpaceSlashPattern, apiRequest, authErrorSelector, authLoadingSelector, authSelector, authUserSelector, cognitoUrl, configureApiRequest, countries, createConfirmation, createHistory, createStore, determineSpan, numericPattern, pageSlice, pageUpdate, refreshTokenUrl, serviceUrls, signOutUrl, states, useAuthentication, useAuthenticationSignOut, usePageUpdate, useUserMenu, useVFormContext, useVPaginatedQuery, useVSkipNav, vSkipNavContext };
